/* src/App.js */
import './App.css'
import axios from 'axios'
import { Buffer } from "buffer"
import { create } from 'ipfs-http-client'
import { decode } from 'content-hash'
import { ethers } from "ethers"
import namehash from 'eth-ens-namehash'
import { useEffect, useState, Fragment, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Route, Routes, useParams, Link, useLocation, useSearchParams, useNavigate } from "react-router-dom"
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import styled from 'styled-components' // TODO: Delete if unused

import '@rainbow-me/rainbowkit/styles.css';

import {
  getDefaultWallets,
  connectorsForWallets,
  trustWallet,
  argentWallet,
  ledgerWallet,
  RainbowKitProvider,
  darkTheme,  // TODO: Delete theme that is unused
  midnightTheme,
  useConnectModal,
  ConnectButton,
} from '@rainbow-me/rainbowkit';

import {
  mainnet,
  goerli,
  configureChains,
  createClient,
  WagmiConfig,
  useAccount,
  useConnect,
  useContractRead,
  useContractWrite,
  useEnsAddress,
  useEnsAvatar,
  usePrepareContractWrite,
  useBalance
} from 'wagmi';

// import { useActiveChainId } from './hooks/useActiveChainId.js'; // Replace with the actual import path
// import { fetchBalance } from '@wagmi/core'

import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'

import { useIsFavorited } from './hooks/useIsFavorited.js';
import { useHeroDismissed } from './hooks/useHeroDismissed.js';

import './fonts/Minecraft.ttf';
import { setUncaughtExceptionCaptureCallback } from 'process'

import { PencilSquareIcon } from '@heroicons/react/20/solid'
import { PencilIcon } from '@heroicons/react/24/outline'
import { CheckIcon } from '@heroicons/react/24/outline'
import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
import { PlusIcon } from '@heroicons/react/24/outline'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { ChevronUpIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { StarIcon } from '@heroicons/react/24/outline'
import { StarIcon as SolidStarIcon } from '@heroicons/react/24/solid'
import { Bars2Icon } from '@heroicons/react/24/solid'
import { Bars3Icon } from '@heroicons/react/24/solid'

import { ReactComponent as CopyButtonSVG } from './assets/svg/copy-button.svg';
import { ReactComponent as CopiedCheckSVG } from './assets/svg/copied-check.svg';
import { ReactComponent as MetamaskIcon } from './assets/svg/metamask-button.svg'
import { ReactComponent as TwitterIcon } from './assets/svg/twitter.svg'
import { ReactComponent as GitHubIcon } from './assets/svg/github.svg'
import { ReactComponent as DiscordIcon } from './assets/svg/discord.svg'

import { Dialog, Transition, Popover } from '@headlessui/react'

import MiddleEllipsis from "react-middle-ellipsis";

import TickerStream from './components/TickerStream';

// Calms the React compiler in the add to metamask code
const { ethereum } = window

window.Buffer = window.Buffer || require("buffer").Buffer; 
Buffer.from('anything','base64');

var addressEncoder = require("@ensdomains/address-encoder")

let editedDataObject = {}
let pendingEdits = false

// const primaryCTAButtonColor = '#3b82f6'

// const primaryCTAButtonColor = '#6ba6ff'
const primaryCTAButtonColor = '#3787fe'
const primaryCTAFontWeight = '600'

// const primaryCTAButtonColor = '#3898FF'

// import { usePrepareContractWrite, useContractWrite } from 'wagmi'

// import Darkmode from 'darkmode-js';
// const darkmodeOptions = {
//   // bottom: '64px', // default: '32px'
//   // right: 'unset', // default: '32px'
//   // left: '32px', // default: 'unset'
//   // time: '0.5s', // default: '0.3s'
//   // mixColor: '#fff', // default: '#fff'
//   backgroundColor: '#fff',  // default: '#fff'
//   // buttonColorDark: '#100f2c',  // default: '#100f2c'
//   buttonColorLight: '#fff', // default: '#fff'
//   saveInCookies: false, // default: true,
//   label: '🌓', // default: ''
//   autoMatchOsTheme: true // default: true
// }
// const darkmode = new Darkmode(darkmodeOptions);
// darkmode.showWidget();

// TODO: Put this on chain, normalize pointers with onchain data, use infinite supported chain data structure
const chainMetadata = {
  arb1_address: {name: "Arbitrum", explorer: 'https://arbiscan.io/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafybeidg2nylzfwu7shb5i6wpbvnwwjkg4j6wffvzrdwoeln4wzr7ythsm'},
  avaxc_address: {name: "Avalanche", explorer: 'https://snowtrace.io/token/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreigtuw2fugvu6ia73dfdqzezsjhekucaj4gpng6bpy7uovsy4rngjm'},
  base_address: {name: "Base", avatar: 'https://gateway.tkn.xyz/ipfs/QmeTRCBht3ZePByS5TgPWNq558UptSTTSUSbzdw33aBDoe'},
  bsc_address: {name: "Binance Smart Chain", explorer: 'https://bscscan.com/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreibxikoxtbygbkckku7ys4iynklfllxs5aq5gaed7sdp5kxri5ny3y'},
  ethereum_address: {name: "Ethereum", explorer: 'https://etherscan.io/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreihilc6eyqjx6nkko2tdswvcwk4fqje3jk55jygptv5pqjeksv7oa4'},
  cro_address: {name: "Cronos", explorer: 'https://cronoscan.com/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreihmypmortotg2ohmzinesgkpfco7sjw2uqzrflidvddllieha64ve'},
  ftm_address: {name: "Fantom", explorer: 'https://ftmscan.com/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreihbji6fwpmky4wt3kautgo2wbpuinsmtjv3t7xbr7sy6cvbez2eei'},
  gno_address: {name: "Gnosis Chain", explorer: 'https://gnosisscan.io/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreid3ex76ck2gqs5myv7qdkijywcaoq7if42geffcoskmd6tcy52cda'},
  goerli_address: {name: "Goerli Testnet", explorer: 'https://goerli.etherscan.io/token/', avatar: 'https://gateway.tkn.xyz/ipfs/QmcG8cCHLaF8x7khVW9dufmSobzSCoVG2JjgVuRE7gmdMq'},
  matic_address: {name: "Polygon", explorer: 'https://polygonscan.com/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafybeifeax54wnp4inieqgbmxk5agxaf7pd72ch5cbphjd3o4oztndhkl4'},
  near_address: {name: "NEAR", explorer: 'https://explorer.near.org/accounts/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreiabff6yov7csr6kiff72fr3rpzqohlzde6qvw4dxnjb4ox2lu7imu'},
  op_address: {name: "Optimism", explorer: 'https://optimistic.etherscan.io/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafybeih3fbrjks4dd7sdz4m4rk6b7qy3qc3d5b5jr5opdjj7tpd76y6c3a'},
  sepolia_address: {name: "Sepolia Testnet", explorer: 'https://sepolia.etherscan.io/token/', avatar: 'https://gateway.tkn.xyz/ipfs/QmZTojA9hHjgWULmqpL8RKKWGhT2cdYeUURAQqXSPTYEPD'},
  sol_address: {name: "Solana", explorer: 'https://explorer.solana.com/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreia3nh4xbpi45y2y2hj3rl24la3z7ninp6cvn56ga6736ytts4uvmq'},
  trx_address: {name: "TRON", explorer: 'https://tronscan.org/#/contract/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreicp533fbm6uwjndbjm6puil5oyhb2xs62alhcrgrmtdoqs5qmxix4'},
  zil_address: {name: "Zilliqa", explorer: 'https://viewblock.io/zilliqa/address/', avatar: 'https://gateway.tkn.xyz/ipfs/bafkreiea4bji7zyx3emsoqq5uewoha4wcrj2apye2lucm6g7ch4wq7dbfm'},
}

const mainnetProviderUrl = `https://eth-mainnet.gateway.pokt.network/v1/lb/62ac232b123e6f0039750629`
const optimismProviderUrl = `https://optimism-mainnet.gateway.pokt.network/v1/lb/62ac232b123e6f0039750629`
const { chains, provider } = configureChains(
  // TODO: Allow two networks without showing the network selector component from rainbowkit
  [mainnet],
  // [goerli],
  [
    jsonRpcProvider({
      rpc: (chain) => {
        switch (chain.id) {
          case 1:
            return {
              // http: `https://necessary-twilight-season.discover.quiknode.pro/8b64026364684c4da9165c356a6ce5625e051c56/`,
              http: mainnetProviderUrl,
            };
          case 5:
            return {
              http: `https://eth-goerli.gateway.pokt.network/v1/lb/62ac232b123e6f0039750629`,
            };
          case 10:
            return {
              http: optimismProviderUrl,
            }
          default:
            throw new Error(`Unsupported chain: ${chain}`);
        }
      },
    }),
  ],
);


// const { chains, provider } = configureChains(
//   [chain.mainnet, chain.polygon, chain.optimism, chain.arbitrum],
//   [
//     // alchemyProvider({ alchemyId: process.env.ALCHEMY_ID }),
//     alchemyProvider({ alchemyId: "O-_u8shdhM-Q4FAwRD5erlF0ORMpiahf" }),
//     jsonRpcProvider({
//       rpc: (chain) => ({
//         http: `https://prettiest-black-meadow.quiknode.pro/d42b56cb76847fe81b599bc282c95263c2d2ad9d/`,
//       }),
//     }),
//     publicProvider()
//   ]
// );
const projectId = 'e5d880eb48096d0e1c8b15f42f54e563';
// const projectId = 'f48733bb9be2806901bb1a7b305e8e91';

const { wallets } = getDefaultWallets({
  appName: 'Token Name Service',
  projectId,
  chains
});
const connectors = connectorsForWallets([
  ...wallets,
  {
    groupName: 'Other',
    wallets: [
      // argentWallet({ projectId, chains }),
      // trustWallet({ projectId, chains }),
      // ledgerWallet({ projectId, chains }),
    ],
  },
]);
const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider
})

const infuraProjectId = '2AEXsKAncCn9wmfQq3evXD3zwPu';   // <---------- your Infura Project ID

const projectSecret = 'f4bf9176406ca9798778a61f5711093d';  // <---------- your Infura Secret
// (for security concerns, consider saving these values in .env files)

const auth = 'Basic ' + Buffer.from(infuraProjectId + ':' + projectSecret).toString('base64');

const ipfsGatewayUrls = [
  'https://gateway.tkn.xyz/ipfs/',
  'https://cloudflare-ipfs.com/ipfs/',
  'https://4everland.io/ipfs/',
  'https://hardbin.com/ipfs/',
  'https://ipfs.eth.aragon.network/ipfs/'
];


const client = create({
  host: 'ipfs.infura.io',
  port: 5001,
  protocol: 'https',
  apiPath: '/api/v0',
  headers: {
    authorization: auth
  }
})
// const client = create({ url: "https://gateway.tkn.xyz/ipfs/" });
// const client = create({
//   host: 'gateway.tkn.xyz',
//   // port: 5001,
//   protocol: 'https',
//   apiPath: '/ipfs/'
// })

const ensRegistryAbi = [{ "inputs": [{ "internalType": "contract ENS", "name": "_old", "type": "address" }], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "operator", "type": "address" }, { "indexed": false, "internalType": "bool", "name": "approved", "type": "bool" }], "name": "ApprovalForAll", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": true, "internalType": "bytes32", "name": "label", "type": "bytes32" }, { "indexed": false, "internalType": "address", "name": "owner", "type": "address" }], "name": "NewOwner", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "address", "name": "resolver", "type": "address" }], "name": "NewResolver", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "uint64", "name": "ttl", "type": "uint64" }], "name": "NewTTL", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "address", "name": "owner", "type": "address" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "operator", "type": "address" }], "name": "isApprovedForAll", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "old", "outputs": [{ "internalType": "contract ENS", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "recordExists", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "resolver", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "operator", "type": "address" }, { "internalType": "bool", "name": "approved", "type": "bool" }], "name": "setApprovalForAll", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "address", "name": "owner", "type": "address" }], "name": "setOwner", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "resolver", "type": "address" }, { "internalType": "uint64", "name": "ttl", "type": "uint64" }], "name": "setRecord", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "address", "name": "resolver", "type": "address" }], "name": "setResolver", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "bytes32", "name": "label", "type": "bytes32" }, { "internalType": "address", "name": "owner", "type": "address" }], "name": "setSubnodeOwner", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "bytes32", "name": "label", "type": "bytes32" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "resolver", "type": "address" }, { "internalType": "uint64", "name": "ttl", "type": "uint64" }], "name": "setSubnodeRecord", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "uint64", "name": "ttl", "type": "uint64" }], "name": "setTTL", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "ttl", "outputs": [{ "internalType": "uint64", "name": "", "type": "uint64" }], "payable": false, "stateMutability": "view", "type": "function" }]
const ensRegistryContractConfig = {
  addressOrName: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
  contractInterface: ensRegistryAbi
}

const resolverAddress = '0x231b0Ee14048e9dCcD1d247744d114a4EB5E8E63' // Resolver.eth changed to hardcoded. In case the official resolver updates, this lookup won't break
const resolverAbi = [{ "inputs": [{ "internalType": "contract ENS", "name": "_ens", "type": "address" }], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": true, "internalType": "uint256", "name": "contentType", "type": "uint256" }], "name": "ABIChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "address", "name": "a", "type": "address" }], "name": "AddrChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "uint256", "name": "coinType", "type": "uint256" }, { "indexed": false, "internalType": "bytes", "name": "newAddress", "type": "bytes" }], "name": "AddressChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "target", "type": "address" }, { "indexed": false, "internalType": "bool", "name": "isAuthorised", "type": "bool" }], "name": "AuthorisationChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "bytes", "name": "hash", "type": "bytes" }], "name": "ContenthashChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "bytes", "name": "name", "type": "bytes" }, { "indexed": false, "internalType": "uint16", "name": "resource", "type": "uint16" }, { "indexed": false, "internalType": "bytes", "name": "record", "type": "bytes" }], "name": "DNSRecordChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "bytes", "name": "name", "type": "bytes" }, { "indexed": false, "internalType": "uint16", "name": "resource", "type": "uint16" }], "name": "DNSRecordDeleted", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "DNSZoneCleared", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": true, "internalType": "bytes4", "name": "interfaceID", "type": "bytes4" }, { "indexed": false, "internalType": "address", "name": "implementer", "type": "address" }], "name": "InterfaceChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "string", "name": "name", "type": "string" }], "name": "NameChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": false, "internalType": "bytes32", "name": "x", "type": "bytes32" }, { "indexed": false, "internalType": "bytes32", "name": "y", "type": "bytes32" }], "name": "PubkeyChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "indexed": true, "internalType": "string", "name": "indexedKey", "type": "string" }, { "indexed": false, "internalType": "string", "name": "key", "type": "string" }], "name": "TextChanged", "type": "event" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "uint256", "name": "contentTypes", "type": "uint256" }], "name": "ABI", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "bytes", "name": "", "type": "bytes" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "addr", "outputs": [{ "internalType": "address payable", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "uint256", "name": "coinType", "type": "uint256" }], "name": "addr", "outputs": [{ "internalType": "bytes", "name": "", "type": "bytes" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }, { "internalType": "address", "name": "", "type": "address" }, { "internalType": "address", "name": "", "type": "address" }], "name": "authorisations", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "clearDNSZone", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "contenthash", "outputs": [{ "internalType": "bytes", "name": "", "type": "bytes" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "bytes32", "name": "name", "type": "bytes32" }, { "internalType": "uint16", "name": "resource", "type": "uint16" }], "name": "dnsRecord", "outputs": [{ "internalType": "bytes", "name": "", "type": "bytes" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "bytes32", "name": "name", "type": "bytes32" }], "name": "hasDNSRecords", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "bytes4", "name": "interfaceID", "type": "bytes4" }], "name": "interfaceImplementer", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes[]", "name": "data", "type": "bytes[]" }], "name": "multicall", "outputs": [{ "internalType": "bytes[]", "name": "results", "type": "bytes[]" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }], "name": "pubkey", "outputs": [{ "internalType": "bytes32", "name": "x", "type": "bytes32" }, { "internalType": "bytes32", "name": "y", "type": "bytes32" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "uint256", "name": "contentType", "type": "uint256" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "setABI", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "uint256", "name": "coinType", "type": "uint256" }, { "internalType": "bytes", "name": "a", "type": "bytes" }], "name": "setAddr", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "address", "name": "a", "type": "address" }], "name": "setAddr", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "address", "name": "target", "type": "address" }, { "internalType": "bool", "name": "isAuthorised", "type": "bool" }], "name": "setAuthorisation", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "bytes", "name": "hash", "type": "bytes" }], "name": "setContenthash", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "setDNSRecords", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "bytes4", "name": "interfaceID", "type": "bytes4" }, { "internalType": "address", "name": "implementer", "type": "address" }], "name": "setInterface", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "string", "name": "name", "type": "string" }], "name": "setName", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "bytes32", "name": "x", "type": "bytes32" }, { "internalType": "bytes32", "name": "y", "type": "bytes32" }], "name": "setPubkey", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "string", "name": "key", "type": "string" }, { "internalType": "string", "name": "value", "type": "string" }], "name": "setText", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes4", "name": "interfaceID", "type": "bytes4" }], "name": "supportsInterface", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "pure", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "node", "type": "bytes32" }, { "internalType": "string", "name": "key", "type": "string" }], "name": "text", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }]
const resolverContractConfig = {
  // addressOrName: '0x4976fb03C32e5B8cfe2b6cCB31c09Ba78EBaBa41', // Would use resolver.eth but registry.tkn.eth statically points to 0x4976.. Update the contract address if the tkn registry points to a newer resolver
  addressOrName: resolverAddress, // TODO: Figure out why using the contract address breaks this query
  contractInterface: resolverAbi
}

const submitterAddr = '0x1FD041DAd3F9eDa8CeD1B6A06a2d2e5fC7602c8b'
const submitterAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"_index","type":"uint256"},{"indexed":true,"internalType":"enum Wise.Status","name":"_status","type":"uint8"}],"name":"StatusChanged","type":"event"},{"inputs":[{"internalType":"uint256","name":"submissionIndex","type":"uint256"}],"name":"approveSubmission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_stakeRequired","type":"uint256"}],"name":"changeSubmissionStake","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"data","type":"string"}],"name":"createSubmission","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"page","type":"uint256"}],"name":"getDescSubmissionsAtPage","outputs":[{"components":[{"internalType":"string","name":"data_cid","type":"string"},{"internalType":"address","name":"submitter","type":"address"},{"internalType":"enum Wise.Status","name":"status","type":"uint8"},{"internalType":"uint256","name":"stake","type":"uint256"}],"internalType":"struct Wise.Submission[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"submissionIndex","type":"uint256"}],"name":"getSubmissionAtIndex","outputs":[{"components":[{"internalType":"string","name":"data_cid","type":"string"},{"internalType":"address","name":"submitter","type":"address"},{"internalType":"enum Wise.Status","name":"status","type":"uint8"},{"internalType":"uint256","name":"stake","type":"uint256"}],"internalType":"struct Wise.Submission","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"page","type":"uint256"}],"name":"getSubmissionsAtPage","outputs":[{"components":[{"internalType":"string","name":"data_cid","type":"string"},{"internalType":"address","name":"submitter","type":"address"},{"internalType":"enum Wise.Status","name":"status","type":"uint8"},{"internalType":"uint256","name":"stake","type":"uint256"}],"internalType":"struct Wise.Submission[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"submissionIndex","type":"uint256"}],"name":"markSubmissionAsSpam","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"submissionIndex","type":"uint256"}],"name":"mergeSubmission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"submissionIndex","type":"uint256"},{"internalType":"uint256","name":"reward","type":"uint256"}],"name":"mergeSubmissionAndPayout","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"submissionIndex","type":"uint256"}],"name":"rejectSubmission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"retrieveTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"stakeRequired","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"submissions","outputs":[{"internalType":"string","name":"data_cid","type":"string"},{"internalType":"address","name":"submitter","type":"address"},{"internalType":"enum Wise.Status","name":"status","type":"uint8"},{"internalType":"uint256","name":"stake","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tkn","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}];
const contractConfig = {
  addressOrName: submitterAddr,
  contractInterface: submitterAbi,
};


const tknHelperAddress = '0xc11BA824ab2cEA5E701831AB87ed43eb013902Dd'
const tknHelperAbi = [ { "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "inputs": [ { "internalType": "string", "name": "_name", "type": "string" } ], "name": "addressesFor", "outputs": [ { "components": [ { "internalType": "address payable", "name": "arb1_address", "type": "address" }, { "internalType": "address payable", "name": "avaxc_address", "type": "address" }, { "internalType": "address payable", "name": "base_address", "type": "address" }, { "internalType": "address payable", "name": "bsc_address", "type": "address" }, { "internalType": "address payable", "name": "cro_address", "type": "address" }, { "internalType": "address payable", "name": "ftm_address", "type": "address" }, { "internalType": "address payable", "name": "gno_address", "type": "address" }, { "internalType": "address payable", "name": "matic_address", "type": "address" }, { "internalType": "bytes", "name": "near_address", "type": "bytes" }, { "internalType": "address payable", "name": "op_address", "type": "address" }, { "internalType": "bytes", "name": "sol_address", "type": "bytes" }, { "internalType": "bytes", "name": "trx_address", "type": "bytes" }, { "internalType": "bytes", "name": "zil_address", "type": "bytes" }, { "internalType": "address payable", "name": "goerli_address", "type": "address" }, { "internalType": "address payable", "name": "sepolia_address", "type": "address" } ], "internalType": "struct TNS.TokenAddresses", "name": "", "type": "tuple" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "string", "name": "_name", "type": "string" } ], "name": "addressFor", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "user", "type": "address" }, { "internalType": "string", "name": "tickerSymbol", "type": "string" } ], "name": "balanceWithTicker", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "string", "name": "_name", "type": "string" } ], "name": "dataFor", "outputs": [ { "components": [ { "internalType": "address", "name": "contractAddress", "type": "address" }, { "internalType": "string", "name": "name", "type": "string" }, { "internalType": "string", "name": "url", "type": "string" }, { "internalType": "string", "name": "avatar", "type": "string" }, { "internalType": "string", "name": "description", "type": "string" }, { "internalType": "string", "name": "notice", "type": "string" }, { "internalType": "string", "name": "version", "type": "string" }, { "internalType": "string", "name": "decimals", "type": "string" }, { "internalType": "string", "name": "twitter", "type": "string" }, { "internalType": "string", "name": "github", "type": "string" }, { "internalType": "bytes", "name": "dweb", "type": "bytes" }, { "internalType": "address payable", "name": "arb1_address", "type": "address" }, { "internalType": "address payable", "name": "avaxc_address", "type": "address" }, { "internalType": "address payable", "name": "base_address", "type": "address" }, { "internalType": "address payable", "name": "bsc_address", "type": "address" }, { "internalType": "address payable", "name": "cro_address", "type": "address" }, { "internalType": "address payable", "name": "ftm_address", "type": "address" }, { "internalType": "address payable", "name": "gno_address", "type": "address" }, { "internalType": "address payable", "name": "matic_address", "type": "address" }, { "internalType": "bytes", "name": "near_address", "type": "bytes" }, { "internalType": "address payable", "name": "op_address", "type": "address" }, { "internalType": "bytes", "name": "sol_address", "type": "bytes" }, { "internalType": "bytes", "name": "trx_address", "type": "bytes" }, { "internalType": "bytes", "name": "zil_address", "type": "bytes" }, { "internalType": "address payable", "name": "goerli_address", "type": "address" }, { "internalType": "address payable", "name": "sepolia_address", "type": "address" } ], "internalType": "struct TNS.Metadata", "name": "", "type": "tuple" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "bytes32", "name": "namehash", "type": "bytes32" } ], "name": "gasEfficientFetch", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "_chainId", "type": "uint256" }, { "internalType": "string", "name": "_name", "type": "string" } ], "name": "getContractForChain", "outputs": [ { "internalType": "bytes", "name": "", "type": "bytes" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "string", "name": "_name", "type": "string" } ], "name": "infoFor", "outputs": [ { "components": [ { "internalType": "address", "name": "contractAddress", "type": "address" }, { "internalType": "string", "name": "name", "type": "string" }, { "internalType": "string", "name": "url", "type": "string" }, { "internalType": "string", "name": "avatar", "type": "string" }, { "internalType": "string", "name": "description", "type": "string" }, { "internalType": "string", "name": "notice", "type": "string" }, { "internalType": "string", "name": "version", "type": "string" }, { "internalType": "string", "name": "decimals", "type": "string" }, { "internalType": "string", "name": "twitter", "type": "string" }, { "internalType": "string", "name": "github", "type": "string" }, { "internalType": "bytes", "name": "dweb", "type": "bytes" } ], "internalType": "struct TNS.TokenInfo", "name": "", "type": "tuple" } ], "stateMutability": "view", "type": "function" } ]
// const tknHelperConfig = {
//   addressOrName: '0xc11BA824ab2cEA5E701831AB87ed43eb013902Dd',
//   contractInterface: tknHelperAbi
// }

const SubmissionStates = ["SUBMITTED", "ACCEPTED", "MERGED", "REJECTED", "SPAM"]

function Content({ setSelectedView, selectedView, connectModalIsOpen, openConnectModal, setShow, setIsModalLoginPromptOpen }) {
  const [queryParameters] = useSearchParams()
  const isIOSFrame = queryParameters.get("frame") == 'ios'

  const [showHero, setShowHero] = useHeroDismissed(isIOSFrame ? false : true);

  // const [showHero, setShowHero] = useState(true)
  // const { data, isError, isLoading } = useAccount()
  const { address, isConnecting, isDisconnected } = useAccount()

  // const [editModeActive, activateEditMode] = useState(false)
  const [dataChanged, handleDataInput] = useState({})

  // Routes:
  // Submissions, edit, detail:ticker, list

  return (
    <>
      <Routes>
        <Route path="/" element={(<>
          {/* {if ((selectedView == "editTokens") && address) {
            return (
              <>
                <Styles>
                  <TokenList selectedView={selectedView} setSelectedView={setSelectedView} handleDataInput={handleDataInput} openConnectModal={openConnectModal} />
                </Styles>
                <SubmissionController dataChanged={dataChanged} submissionData={address} setSelectedView={setSelectedView} />
              </>
            )
          }} */}
          {showHero && (
            <LeftAlignedHero setSelectedView={setSelectedView} loggedInAddress={address} buttonClicked={setSelectedView} openConnectModal={openConnectModal} setShowHero={setShowHero} />
          )}
          {/* <CTAHero loggedInAddress={address} buttonClicked={setSelectedView} openConnectModal={openConnectModal} /> */}
          <TokenList selectedView={selectedView} setSelectedView={setSelectedView} openConnectModal={openConnectModal} setShowHero={setShowHero} />
          {!isIOSFrame &&
            <EditButton loggedInAddress={address} setSelectedView={setSelectedView} openConnectModal={openConnectModal} />
          }
        </>)} />
        <Route path="/edit/:query" element={(<>
          <div className="mb-72">
            <Styles>
              <TokenList selectedView={selectedView} setSelectedView={setSelectedView} handleDataInput={handleDataInput} openConnectModal={openConnectModal} setShowHero={setShowHero} />
            </Styles>
            <SubmissionController dataChanged={dataChanged} submissionData={address} setSelectedView={setSelectedView} setIsModalLoginPromptOpen={setIsModalLoginPromptOpen} />
          </div>
        </>)} />
        <Route path="/edit" element={(<>
          <div className="mb-72">
            <Styles>
              <TokenList selectedView={selectedView} setSelectedView={setSelectedView} handleDataInput={handleDataInput} openConnectModal={openConnectModal} setShowHero={setShowHero} />
            </Styles>
            <SubmissionController dataChanged={dataChanged} submissionData={address} setSelectedView={setSelectedView} setIsModalLoginPromptOpen={setIsModalLoginPromptOpen} />
          </div>
        </>)} />
        <Route path="/portfolio" element={(<>
          <TokenList selectedView={selectedView} setSelectedView={setSelectedView} openConnectModal={openConnectModal} setShowHero={setShowHero} />
          {!isIOSFrame &&
            <EditButton loggedInAddress={address} setSelectedView={setSelectedView} openConnectModal={openConnectModal} />
          }
        </>)} />
        <Route path="/search/:query" element={(<>
          <TokenList selectedView={selectedView} setSelectedView={setSelectedView} openConnectModal={openConnectModal} setShowHero={setShowHero} />
          {!isIOSFrame &&
            <EditButton loggedInAddress={address} setSelectedView={setSelectedView} openConnectModal={openConnectModal} />
          }
        </>)} />
        <Route path="/search" element={(<>
          <TokenList selectedView={selectedView} setSelectedView={setSelectedView} openConnectModal={openConnectModal} setShowHero={setShowHero} />
          {!isIOSFrame &&
            <EditButton loggedInAddress={address} setSelectedView={setSelectedView} openConnectModal={openConnectModal} />
          }
        </>)} />
        <Route path="/submissions" element={<SubmissionList />} />
        <Route path="/tokens/:ticker" element={<TokenDetail />} />
        <Route path="/:ticker" element={<TokenDetail />} />
      </Routes>
    </>
  )


  if (selectedView == "submissions") {
    return (
      <SubmissionList />
    )
  }
  else if ((selectedView == "editTokens") && address) {
    return (
      <>
        <Styles>
          <TokenList selectedView={selectedView} setSelectedView={setSelectedView} handleDataInput={handleDataInput} openConnectModal={openConnectModal} />
        </Styles>
        <SubmissionController dataChanged={dataChanged} submissionData={address} setSelectedView={setSelectedView} />
      </>
    )
  }
  else if (address) {
    return (
      <>
        {showHero && (
          <LeftAlignedHero loggedInAddress={address} setSelectedView={setSelectedView} openConnectModal={openConnectModal} setShowHero={setShowHero} />
        )}
        {/* <CTAHero loggedInAddress={address} setSelectedView={setSelectedView} openConnectModal={openConnectModal} /> */}
        <TokenList selectedView={selectedView} setSelectedView={setSelectedView} openConnectModal={openConnectModal} />
        <EditButton loggedInAddress={address} setSelectedView={setSelectedView} openConnectModal={openConnectModal} />
      </>
    )
  } else {
    return (
      <>
        {showHero && (
          <LeftAlignedHero loggedInAddress={address} buttonClicked={setSelectedView} openConnectModal={openConnectModal} setShowHero={setShowHero} />
        )}
        {/* <CTAHero loggedInAddress={address} buttonClicked={setSelectedView} openConnectModal={openConnectModal} /> */}
        <TokenList selectedView={selectedView} setSelectedView={setSelectedView} openConnectModal={openConnectModal} />
        <EditButton loggedInAddress={address} setSelectedView={setSelectedView} openConnectModal={openConnectModal} />
      </>
    )
  }
}

const MediaStyle = styled.div`
  @media only screen and (min-width: 1024px) {
    .token-table-container {
      display: grid;
      place-content: center;
    }
  }
`

const SearchForm = ({ filteredTokens, setSearchString, setListViewState, setShowHero, shouldFocus, providedSearchString }) => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname
  const isInEditMode = pathname.startsWith('/edit');

  const [searchText, setSearchText] = useState(providedSearchString ? providedSearchString : '');
  const debounceTimeoutRef = useRef(null); // Reference to store the debounce timeout

  const inputReference = useRef(null);
  useEffect(() => {
    if (shouldFocus) {
      inputReference.current.focus();
    }
  }, []);

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setSearchText(inputValue)

    console.log('User typed:', inputValue);

    // Clear the existing debounce timeout if there is one
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    // Set a new debounce timeout
    debounceTimeoutRef.current = setTimeout(() => {
      submitSearchStateUpdate(inputValue)
      console.log('Action triggered after debounce:', inputValue);
    }, 300); // 1000ms delay (1 second)
  };

  const submitSearchStateUpdate = (searchText) => {
    setSearchString(searchText);
    // setSearchText(searchText);
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    // Perform the search action here
    console.log('Search submitted:', searchText);
    document.activeElement.blur()
  
    // navigate to the first search result
    if (filteredTokens.length > 0 && !isInEditMode) {
      navigate(`/${filteredTokens[0]}`);
    }
  };
  

  // Event handler for the onFocus event of the search input element
  const handleSearchFocus = () => {
    // Clear the items from the TokenList by setting the state to an empty array
    setShowHero(false)
    console.log("User changed focus to search input")
    setListViewState('search')
    // setTokenListItems([]);
  };

  const handleSearchBlur = () => {
    // Clear the items from the TokenList by setting the state to an empty array
    console.log("User removed focus from search input")
    if (searchText === '') {
      console.log("User exited search with empty field. Return to home list.")
      setListViewState('list')
    }
    // setTokenListItems([]);
  };

  return (
    <form className="m-0 sm:mx-6 sm:mb-6 md:mb-0 md:mt-0 lg:mb-6 lg:mt-0" onSubmit={handleSubmit}>
      <label
        htmlFor="default-search"
        className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
      >
        Search
      </label>
      <div className="relative w-full mx-auto">
        <div className="absolute inset-y-0 left-0 flex items-center pl-5 pointer-events-none">
          <svg
            aria-hidden="true"
            className="w-5 h-5 text-gray-500 dark:text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            ></path>
          </svg>
        </div>
        <input
          ref={inputReference}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          type="search"
          id="default-search"
          className="block w-full p-4 text-xl font-sans font-semibold bg-white mb-5 mt-1.5 text-gray-900 border border-gray-300 rounded-xl  focus:ring-blue-500 focus:border-blue-500 shadow-sm"
          placeholder="Token Name or Symbol"
          required
          value={searchText}
          onChange={handleInputChange}
          onFocus={handleSearchFocus}
          onBlur={handleSearchBlur}
          style={{ WebkitAppearance: "none", paddingLeft: "3.25rem" }}
        />

        {/* Clear input button */}
        {searchText && (
          <button
            type="button"
            className="absolute inset-y-0 right-0 flex items-center px-5 py-2 cursor-pointer focus:outline-none"
            onClick={() => handleInputChange({ target: { value: '' } })}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4 text-gray-500 dark:text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
    </form>
  );
};


const TokenDetail = () => {
  const { ticker } = useParams()
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [token, setToken] = useState({})
  const [copiedCheckVisible, setCopiedCheckVisible] = useState(false);
  const [overlayVisible, setOverlayVisible] = useState(false);

  // const favoritesArray = useSelector((state) => state.favoritesArray);
  const dispatch = useDispatch();

  const isFavorited = useIsFavorited(ticker)

  const { data: tokenData, isSuccess, isFetching } = useContractRead({
    address: tknHelperAddress,
    abi: tknHelperAbi,
    functionName: 'dataFor',
    args: [ticker.toLowerCase()],
  })

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      try {
        const result = await axios(`https://feed.tkn.xyz/p/${ticker}`);
        setData(result.data.USD);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [ticker]);

  const favoriteToken = () => {
    addFavorite(ticker)
    console.log(ticker, "Favorited")
    // console.log("favorites:", favoritesArray)
  }

  const unFavoriteToken = () => {
    removeFavorite(ticker)
    console.log(ticker, "Un-Favorited")
    // console.log("favorites:", favoritesArray)
  }

  const addFavorite = (item) => {
    dispatch({ type: 'ADD_FAVORITE', payload: item });
  };

  const removeFavorite = (item) => {
    dispatch({ type: 'REMOVE_FAVORITE', payload: item });
  };

  // if (loading || contractDataLoading) {
  //   return <div>Loading...</div>;
  // }


  let CHANGEPCT24HOUR, PRICE, LASTUPDATE, CIRCULATINGSUPPLYMKTCAP, CHANGEPCTHOUR, TOTALTOPTIERVOLUME24HTO, CHANGE24HOUR, CHANGEHOUR, MKTCAP, TOTALVOLUME24HTO, LASTVOLUMETO;
  if (!data) {
    // Failing elegantly and proceeding to render onchain data
    console.log(`Failed to fetch ${ticker} data from feed.tkn.xyz/p/${ticker}`)
  } else {
    ({ CHANGEPCT24HOUR, PRICE, LASTUPDATE, CIRCULATINGSUPPLYMKTCAP, CHANGEPCTHOUR, TOTALTOPTIERVOLUME24HTO, CHANGE24HOUR, CHANGEHOUR, MKTCAP, TOTALVOLUME24HTO, LASTVOLUMETO } = data);
  }

  return (
    <div className="flex items-center justify-center" style={{ minHeight: '84vh' }}>
      <div className="w-full max-w-md bg-white rounded-xl shadow-sm p-8 space-y-2 border m-3">
        <div className="flex items-center justify-between">
          <div className='flex items-center justify-center' onClick={() => {
            if (navigator.clipboard) {
              navigator.clipboard.writeText(tokenData.avatar);
            } else if (window.clipboardData) { // Internet Explorer
              window.clipboardData.setData('Text', tokenData.avatar);
            } 
            setCopiedCheckVisible(true);
            setOverlayVisible(true);
            setTimeout(() => {
              setCopiedCheckVisible(false);
              setOverlayVisible(false);
              console.log("Dismissing image url copy overlay")
              const copyHoverElement = document.getElementById('copy-hover');
              if (copyHoverElement) {
                copyHoverElement.parentNode.removeChild(copyHoverElement);
              }
            }, 3000);
          }}>
            {(tokenData && tokenData.avatar) ? (
              <div className="relative group cursor-pointer">
                  <div id="copy-hover" className={`rounded-md absolute inset-0 bg-gray-300  group-hover:visible ${copiedCheckVisible ? 'visible' : 'invisible'}`} style={{ opacity: '0.9' }}>
                    <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-bold">Copy</span>
                  </div>
                  <div id="copy-backdrop" className={`rounded-md overlay absolute inset-0 bg-gray-300 opacity-0 ${overlayVisible ? 'visible' : 'invisible'}`}></div>
                  <ImageFromIPFS className="rounded-md" width={50} height={50} src={tokenData.avatar} alt={`${ticker} Token Logo`}/>
                  <svg className={`${copiedCheckVisible ? 'visible' : 'invisible'} copiedCheck absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2`} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" ><path fill="#fff" d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"></path></svg>
              </div>

            ) : (
              <p>Loading...</p>
            )}
          </div>
          <h2 className="text-4xl font-bold text-left">{ticker.toUpperCase()}</h2>
          <div className="text-gray-500 text-xs align-top">
            {
              isFavorited ? (
                <SolidStarIcon className='cursor-pointer' style={{ color: 'gold', height: '50px', width: '50px' }} onClick={unFavoriteToken}/>
              ) : (
                <StarIcon className='cursor-pointer' style={{ height: '50px', width: '50px' }} onClick={favoriteToken}/>
              )
            }
          </div>
        </div>

        <div className="text-3xl font-semibold text-center text-neutral-600 mt-2.5" style={{ marginBottom: '12px', marginTop: '0px'}}> 
          {tokenData && tokenData.name} 
        </div>

        {tokenData && tokenData.notice && ( <>
          {/* <div className="text-gray-400 text-lg font-medium text-left">Notice</div> */}
          <div className="bg-yellow-100 p-3 mt-4 mb-6 rounded-lg">
            <div className="text-gray-600 mt-0 text-lg font-semibold text-left">{tokenData.notice}</div>
          </div>
          </>
        )}

        {data &&
          <>
            <div className="grid grid-cols-7 gap-2" style={{ marginLeft: '-16px', marginRight: '-16px' }}>
              <div className="col-span-3 bg-gray-300 p-3 rounded-md flex items-center justify-center font-semibold text-2xl break-all">
                {PRICE}
              </div>
              <div 
                className={`col-span-2 p-3 rounded-md flex items-center justify-center font-semibold text-xl
                ${CHANGEPCTHOUR >= 0 ? 'bg-green-200' : 'bg-red-200'}`}
              >
                {CHANGEPCTHOUR}%
              </div>
              <div 
                className={`col-span-2 p-3 rounded-md flex items-center justify-center font-semibold text-xl
                ${CHANGEPCT24HOUR >= 0 ? 'bg-green-400' : 'bg-red-400'}`}
              >
                {CHANGEPCT24HOUR}%
              </div>
              <div className="col-span-3  p-1 rounded-md flex items-center justify-center text-sm -mt-2.5 font-semibold text-md">
                Price
              </div>
              <div className="col-span-2  p-1 rounded-md flex items-center justify-center text-sm -mt-2.5 font-semibold text-md">
                Hour
              </div>
              <div className="col-span-2  p-1 rounded-md flex items-center justify-center text-sm -mt-2.5 font-semibold text-md">
                24h
              </div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <div className="text-gray-400 text-lg font-medium text-left">Market Cap</div>
                <div className="text-gray-600 mt-0.5 text-lg font-semibold text-left">{MKTCAP}</div>
              </div>
              <div>
                <div className="text-gray-400 text-lg font-medium text-left">24 Hour Volume</div>
                <div className="text-gray-600 mt-0.5 text-lg font-semibold text-left">{TOTALVOLUME24HTO == "$ 0" ? LASTVOLUMETO : TOTALVOLUME24HTO}</div>
              </div>
            </div>
            {data &&
              <div className="text-gray-500 text-xs">
                Last updated: {LASTUPDATE}
              </div>
            }
          </>
        }

        <div className="text-gray-400 text-lg font-medium text-left" style={{marginTop: '4px'}}>Description</div>
        <div className="text-gray-600 mt-0 text-lg font-semibold text-left" style={{marginTop: '2px'}}>{(tokenData && tokenData.description) ? tokenData.description : ""}</div>
        <div className="mt-8 space-y-4">
          <div className="grid grid-cols-2 gap-2">


          <div className="text-gray-400 text-lg font-medium text-left">Website</div>
          <div className="text-gray-600 mt-0 text-lg font-semibold text-left">
            <a
              className="hover:underline break-all"
              href={tokenData && tokenData.url}
              target="_blank"
              rel="noreferrer"
            >
              {tokenData && tokenData.url.replace("https://", "").replace("http://", "").replace(/\/$/, "").replace("www.", "")}
            </a>
          </div>
          <div className="text-gray-400 text-lg font-medium text-left">Twitter</div>
          <div className="text-gray-600 mt-0 text-lg font-semibold text-left">
            <a
              className="hover:underline"
              href={`https://twitter.com/${tokenData && tokenData.twitter}`}
              target="_blank"
              rel="noreferrer"
            >
              {tokenData && tokenData.twitter && "@" + tokenData.twitter}
            </a>
          </div>
          <div className="text-gray-400 text-lg font-medium text-left">GitHub</div>
          <div className="text-gray-600 mt-0 text-lg font-semibold text-left">
            <a
              className="hover:underline"
              href={tokenData && 'https://github.com/' + tokenData.github}
              target="_blank"
              rel="noreferrer"
            >
              {tokenData && tokenData.github}
            </a>
          </div>
          <div className="text-gray-400 text-lg font-medium text-left">DWeb Gateway</div>
          <div className="text-gray-600 mt-0 text-lg font-semibold text-left break-all">
            <a href={'https://'+ticker.toLowerCase()+'.tkn.link' } target="_blank">{tokenData && tokenData.dweb != '0x' ? ""+ticker.toLowerCase()+".tkn.link" : ""}</a>
          </div>
          <div className="text-gray-400 text-lg font-medium text-left">DWeb CID</div>
          <div className="text-gray-600 mt-0 text-lg font-semibold text-left break-all">  { tokenData && tokenData.dweb ? (tokenData.dweb === '0x' ? "" : decode(tokenData.dweb)) : ""}
</div>
          {/* <div className="text-gray-600 mt-0 text-lg font-semibold text-left break-all">{ tokenData &&
            tokenData.dweb === '0x' ? "" : decode(tokenData.dweb)
          }</div> */}
          <div className="text-gray-400 text-lg font-medium text-left">Decimals</div>
          <div className="text-gray-600 mt-0 text-lg font-semibold text-left">{tokenData && tokenData.decimals}</div>
          <div className="text-gray-400 text-lg font-medium text-left">Version</div>
          <div className="text-gray-600 mt-0 text-lg font-semibold text-left">{tokenData && tokenData.version}</div>

          </div>
          {tokenData &&
            <ContractAddressList tokenData={ tokenData } ticker={ ticker } />
          }
        </div>

        <div className="mt-8">
          <Link to={`/edit/${ticker.toLowerCase()}`} style={{ backgroundColor: primaryCTAButtonColor }} className=" hover:bg-blue-700 text-white font-bold py-2 px-4 w-full rounded flex items-center justify-center">
            Edit {ticker.toUpperCase()}
          </Link>

          {/* <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 w-full rounded">
            Edit {ticker}
          </button> */}
        </div>
          {/* Twitter embed seems to be deactivated by corporate */}
          {/* {tokenData && tokenData.twitter && 
            <div className="!mt-7">
              <TwitterTimeline twitterHandle={tokenData && tokenData.twitter} />
            </div>
          }

          {false && tokenData && tokenData.github && 
          // TODO: Put Github Widget Here
            <div className="!mt-8">
              <TwitterTimeline twitterHandle={tokenData && tokenData.twitter} />
            </div>
          } */}
      </div>
    </div>
  );
};

const TwitterTimeline = ({ twitterHandle }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <a
      className="twitter-timeline"
      data-width="420"
      data-height="500"
      href={`https://twitter.com/${twitterHandle}?ref_src=twsrc%5Etfw`}
    >
    </a>
  );
};

function ContractAddressList({ tokenData, ticker }) {
  // console.log(tokenData)
  
  let addresses = Object.entries(tokenData)
    .filter(([key, value]) => key.includes('address') && value !== "0x" && value !== "0x0000000000000000000000000000000000000000")
    .map(([key, value]) => ({[key]: value}));
  
    if (tokenData['contractAddress'] && tokenData['contractAddress'] !== "0x0000000000000000000000000000000000000000") {
      let ethAddress = {'ethereum_address': tokenData['contractAddress']};
      addresses = addresses.filter(address => address !== ethAddress);
      addresses.unshift(ethAddress);
    }
    
  
  // console.log(addresses);

  const [copiedIdx, setCopiedIdx] = useState(null);

  const handleCopy = (address, idx) => {
    navigator.clipboard.writeText(address)
      .then(() => {
        console.log('Address copied to clipboard!');
        setCopiedIdx(idx);
      })
      .catch(err => {
        console.error('Could not copy text: ', err);
      });
  }

  useEffect(() => {
    if (copiedIdx !== null) {
      setTimeout(() => {
        setCopiedIdx(null);
      }, 3000);
    }
  }, [copiedIdx]);

  // const handleAddToMetamask = (address) => {
  //   console.log("Adding to metamask:", address)
  //   // function to add address to Metamask
  // }

  async function handleAddToMetamask(address, metadata, ticker) {
    try {
      // wasAdded is a boolean. Like any RPC method, an error may be thrown.
  
      const wasAdded = await ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', // Initially only supports ERC20, but eventually more!
          options: {
            address: address, // The address that the token is at.
            symbol: ticker.toUpperCase(), // A ticker symbol or shorthand, up to 5 chars.
            decimals: tokenData.decimals, // The number of decimals in the token
            image: tokenData.avatar, // A string url of the token logo
          },
        },
      });
  
      if (wasAdded) {
        // console.log('Thanks for your interest!');
      } else {
        // console.log('Your loss!');
      }
    } catch (error) {
      console.log(error);
    }
  }

  const processAddress = (address) => {
    if (Object.keys(address)[0] == 'near_address') {
      return addressEncoder.formatsByName['NEAR'].encoder(Buffer.from(Object.values(address)[0].substring(2), 'hex'))
    } else if (Object.keys(address)[0] == 'sol_address') {
      return addressEncoder.formatsByName['SOL'].encoder(Buffer.from(Object.values(address)[0].substring(2), 'hex'))
    } else if (Object.keys(address)[0] == 'trx_address') {
      return addressEncoder.formatsByName['TRX'].encoder(Buffer.from(Object.values(address)[0].substring(2), 'hex'))
    } else if (Object.keys(address)[0] == 'zil_address') {
      return addressEncoder.formatsByName['ZIL'].encoder(Buffer.from(Object.values(address)[0].substring(2), 'hex'))
    } else {
      return Object.values(address)[0]
    }
  }

  const isEVM = (address) => {
    if (Object.keys(address)[0] == 'near_address') { return false
    } else if (Object.keys(address)[0] == 'sol_address') { return false
    } else if (Object.keys(address)[0] == 'trx_address') { return false
    } else if (Object.keys(address)[0] == 'zil_address') { return false
    } else { return true }
  }

  return (
    <fieldset>
      <legend className="text-base font-semibold text-gray-900">Token Contracts</legend>
      <div className="mt-4 divide-y divide-gray-200 border-b border-t border-gray-200 mb-4">
        {addresses.map((address, addressIdx) => (
          <div key={addressIdx} className="relative flex items-start justify-between py-4">
            <div className="min-w-0 flex-1 text-sm leading-6 flex items-center">
              <ImageFromIPFS 
                style={{ borderRadius: "5px" }} 
                width={30} 
                height={30} 
                src={chainMetadata[Object.keys(address)[0]].avatar} 
                alt="" 
                className="mr-2"
              />
              {/* <img style={{ borderRadius: "5px" }} width={30} height={30} src={chainMetadata[Object.keys(address)[0]].avatar} alt="" className="mr-2"/> */}
              <div className="flex flex-col break-all text-left ml-2" style={{ width: "300px", whiteSpace: "nowrap" }}>
                <label htmlFor={`side-${addressIdx}`} className="text-base select-none font-medium text-gray-900 text-left font-bold">
                  {chainMetadata[Object.keys(address)[0]].name}
                </label>
                <div style={{ marginTop: '1px' }}>
                <MiddleEllipsis >
                  <a className='text-sm truncate' target="_blank" href={chainMetadata[Object.keys(address)[0]].explorer + processAddress(address)} style={{ wordWrap: "break-word" }}>
                    {processAddress(address)}
                  </a>
                </MiddleEllipsis>
                </div>
              </div>
            </div>
            <div className="ml-3 flex h-6" style={{ position: 'absolute', top: '14px', right: '0px' }}>
              {isEVM(address) &&
                <MetamaskIcon className='mr-3' style={{ width: "20px", height: "20px", cursor: 'pointer', transform: 'translateX(1px)' }}
                  onClick={() => handleAddToMetamask(Object.values(address)[0], chainMetadata[Object.keys(address)[0]], ticker)} />
              }
              {copiedIdx === addressIdx ? (
                <CopiedCheckSVG onClick={() => handleCopy(processAddress(address), addressIdx)} />
              ) : (
                <CopyButtonSVG style={{ cursor: 'pointer' }} onClick={() => handleCopy(processAddress(address), addressIdx)} />
              )}
            </div>
          </div>
        ))}
      </div>
    </fieldset>
  )
}

function TokenList({ handleDataInput, openConnectModal, setShowHero }) {
  const { query } = useParams()
  const pathname = useLocation().pathname
  const isInEditMode = pathname.startsWith('/edit');
  const editSearchPath = pathname.split('/edit/')[1];
  const isInSearchUrl = pathname.startsWith('/search')
  const isInPortfolioView = pathname == "/portfolio"
  const [list, setList] = useState('')
  const [detailLevel, setDetailLevel] = useState('expanded')
  const [editNewToken, setEditNewToken] = useState(false)
  const [prices, setPrices] = useState({})
  const [page, setPage] = useState(0)
  const [searchString, setSearchString] = useState(query ? query : '')
  const [filteredTokens, setFilteredTokens] = useState([]);
  const [dataIsLoading, setDataIsLoading] = useState(true)
  const [searchMedia, setSearchMedia] = useState([])
  // TODO: Convert to typescript
  // type ListViewState = 'home' | 'search' | 'mkt-cap';
  // const [listViewState, setListViewState] = useState<ListViewState>('list');

  // const viewStateFromUrl = isInSearchUrl
  const [listViewState, setListViewState] = useState('list');
  // NOTE: listViewStates: 'list', 'search'

  // console.log("query, searchstring", query, searchString)

  const [selectedView, setSelectedView] = useState('')

  // const favoritesArray = useSelector((state) => state.favoritesArray);
  
  // Show newest favorites at the top
  const favoritesArray = useSelector((state) => state.favoritesArray.slice().reverse());

  // console.log("Using search string", searchString)
  // console.log("Is in edit mode:", isInEditMode)
  // console.log("params", query)
  // console.log({ listViewState })

  const shouldShowLoading = () => {
    return true
  }

  const queryGatewayWithBackups = async (cid) => {
    for (const gateway of ipfsGatewayUrls) {
      try {
        const resp = await axios.get(`${gateway}${cid}`);
        return resp.data;
      } catch (error) {
        console.warn(`Failed to fetch from ${gateway}, trying the next gateway...`);
        continue;
      }
    }
    throw new Error('All gateways failed');
  };

  const getList = async (cid) => {
    try {
      const data = await queryGatewayWithBackups(cid);
      console.log("Processing on chain registry data");
      setList(data);
    } catch (error) {
      console.error('Failed to fetch list', error);
    }
  };
  
  const getSearchMedia = async (cid) => {
    try {
      const data = await queryGatewayWithBackups(cid);
      setSearchMedia(data);
    } catch (error) {
      console.error('Failed to fetch search media', error);
    }
  };

  const getPaginatedTokenList = () => {
    const tokenArray = Object.keys(list)
    const total = (page + 1) * 100
    if (total > tokenArray.length) {
      return {tokens: tokenArray.slice(0, tokenArray.length), finished: true}
    } else {
      return {tokens: tokenArray.slice(0, total), finished: false};
    }
  }

  // useEffect(() => {
  //   const search = pathname.split('/edit/')[1];
  //   if (search) {
  //     setSearchString(search);
  //   }
  // }, [pathname]);
  

  useEffect(() => {
    if (isInPortfolioView) {
      setListViewState('portfolio')
    } else if (isInSearchUrl) {
      setListViewState('search')
    }

  }, [isInPortfolioView])

  function filterTokensForSearchTerm(searchTerm) {
    const searchResults = Object.entries(searchMedia)
      .filter(([key, value]) => {
        // Check if the key starts with the search term (case-insensitive)
        const keyMatch = key.toLowerCase().startsWith(searchTerm.toLowerCase());
        
        // Check if any word in the value starts with the search term (case-insensitive)
        const valueMatch = value.split(" ").some(word => word.toLowerCase().startsWith(searchTerm.toLowerCase()));
        
        return keyMatch || valueMatch;
      })
      .map(([key, value]) => key); // Extract only the keys from the filtered entries
      
    return searchResults;
  }

  useEffect(() => {
    const filterTokens = () => {
      const lowerCaseSearchText = searchString.toLowerCase();
      if (lowerCaseSearchText === '') {
        setFilteredTokens([])
      } else {
        console.log("Filtering tokens", Object.entries(searchMedia).length, "  for", lowerCaseSearchText)
        const searchResults = Object.entries(searchMedia)
        .filter(([key, value]) => {
          // Check if the key starts with the search term (case-insensitive)
          const keyMatch = key.toLowerCase().startsWith(lowerCaseSearchText);
          
          // Check if any word in the value starts with the search term (case-insensitive)
          const valueMatch = value.split(" ").some(word => word.toLowerCase().startsWith(lowerCaseSearchText));
          
          return keyMatch || valueMatch;
        })
        .map(([key, value]) => key); // Extract only the keys from the filtered entries        
        // console.log("Search results:", searchResults)
        setFilteredTokens(searchResults);
      }
    };

    filterTokens();
  }, [searchString, list, searchMedia]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // TODO: Fail elegantly if the price api is down, render the remainder
        const response = await fetch(`https://feed.tkn.xyz/prices/page/all`);
        const prices = await response.json();
        setPrices(prices);
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [])

  useEffect(() => {
    // Preload included registry before fetching the latest data from the main chain
    // if (listViewState == "list") {
      const preloadedRegistry = { "BTC": {}, "ETH": {}, "USDT": { "swp_deployed": true }, "USDC": { "swp_deployed": true }, "UNI": {}, "TKN": {}, "LINK": {}, "WBTC": {}, "MATIC": {}, "DAI": { "swp_deployed": true }, "GRT": {}, "OKB": {}, "CUSDC": {}, "AAVE": {}, "BUSD": {}, "CETH": {}, "OP": {}, "ARB": {}, "SHIB": { "swp_deployed": true }, "AXS": {}, "CRO": {}, "MKR": {}, "AMP": {}, "LEO": {}, "STETH": {}, "CEL": {}, "QNT": {}, "SUSHI": {}, "COMP": {}, "WAVES": {}, "HT": {}, "UST": {}, "SNX": {}, "HOT": {}, "HBTC": {}, "CHZ": {}, "ENJ": {}, "TUSD": {}, "YFI": {}, "AUDIO": {}, "VGX": {}, "FTM": {}, "BAT": {}, "MANA": {}, "XSUSHI": {}, "NEXO": {}, "TEL": {}, "BNT": {}, "KCS": {}, "ZRX": {}, "NXM": {}, "TITAN": {}, "PERP": {}, "ANKR": {}, "OMG": {}, "CRV": {}, "CUSDT": {}, "UMA": {}, "RENBTC": {}, "LUSD": {}, "1INCH": {}, "UOS": {}, "RSR": {}, "SAND": {}, "REN": {}, "LPT": {}, "CDAI": {}, "FEI": {}, "SRM": {}, "GLM": {}, "LRC": {}, "SKL": {}, "FET": {}, "MIR": {}, "ALPHA": {}, "SNT": {}, "WOO": {}, "OCEAN": {}, "PAXG": {}, "GNO": {}, "OGN": {}, "OHM": {}, "SUSD": {}, "SETH": {}, "TRIBE": {}, "BAL": {}, "ALUSD": {}, "NMR": {}, "BADGER": {}, "QUICK": {}, "ALCX": {}, "KEEP": {}, "DPI": {}, "ZKS": {}, "REP": {}, "ANT": {}, "STORJ": {}, "RAD": {}, "WNXM": {}, "SBTC": {}, "FARM": {}, "AMPL": {}, "LDO": {}, "CREAM": {}, "RARE": {}, "DNT": {}, "INST": {}, "POLS": {}, "BOND": {}, "HEGIC": {}, "INDEX": {}, "BAO": {}, "NFTX": {}, "TORN": {}, "SOCKS": {}, "SPELL": {}, "SDT": {}, "MVI": {}, "XTK": {}, "FOAM": {}, "ICE": {}, "DIGG": {}, "YAM": {}, "SALT": {}, "MIM": {}, "DYDX": {}, "ENS": {}, "CVX": {}, "RAI": {}, "FRAX": {}, "WSTR": {}, "BOBA": {}, "IMX": {}, "RLY": {}, "SYN": {}, "CVC": {}, "ETH2X-FLI": {}, "CELR": {}, "REQ": {}, "WLUNA": {}, "GTC": {}, "GALA": {}, "ROOK": {}, "KP3R": {}, "RGT": {}, "BNB": {}, "SOL": {}, "XRP": {}, "ADA": {}, "LUNA": {}, "AVAX": {}, "DOT": {}, "DOGE": {}, "LTC": {}, "ALGO": {}, "BCH": {}, "TRX": {}, "XLM": {}, "ATOM": {}, "APE": {}, "HNS": {}, "BLUR": {}, "HBAR": {}, "VET": {}, "NEAR": {}, "FIL": {}, "EGLD": {}, "ETC": {}, "ICP": {}, "THETA": {}, "XTZ": {}, "FTT": {}, "XMR": {}, "HNT": {}, "KLAY": {}, "EOS": {}, "CAKE": {}, "MIOTA": {}, "AR": {}, "ONE": {}, "FLOW": {}, "BTT": {}, "KSM": {}, "BSV": {}, "XRD": {}, "STX": {}, "RUNE": {}, "TFUEL": {}, "ZEC": {}, "NEO": {}, "KDA": {}, "CELO": {}, "OMI": {}, "DASH": {}, "LN": {}, "IOTX": {}, "XEM": {}, "OSMO": {}, "MINA": {}, "DCR": {}, "KUB": {}, "QTUM": {}, "DESO": {}, "ROSE": {}, "SAFEMOON": {}, "WAXP": {}, "ICX": {}, "RVN": {}, "HERO": {}, "ZIL": {}, "BTG": {}, "JEWEL": {}, "SC": {}, "ZEN": {}, "TIME": {}, "IOST": {}, "SCRT": {}, "OKT": {}, "ONT": {}, "CKB": {}, "RAY": {}, "HIVE": {}, "KAVA": {}, "DGB": {}, "WRX": {}, "LQTY": {}, "AGIX":{},"TKX":{},"RNDR":{},"BIT":{},"FXS":{},"TON":{},"GT":{},"USDD":{},"XAUT":{},"BGB":{},"WBT":{},"ELON":{},"BONE":{},"FLOKI":{},"JASMY":{},"BAND":{},"ACH":{},"BTSE":{},"NU":{},"DAO":{},"CDT":{},"BICO":{},"INJ":{},"MASK":{},"GMT":{},"GUSD":{},"BABYDOGE":{},"MAGIC":{},"CVXCRV":{},"SSV":{},"MX":{},"CTC":{},"XDATA":{},"KISHU":{},"SAI":{},"AVINOC":{},"SAITAMA":{},"LEND":{},"POLY":{},"FEG":{},"REV":{},"XYO":{},"KNCL":{},"DENT":{},"VRA":{},"LOOKS":{},"NPXS":{},"HOGE":{},"UFO":{}, "RPL": {}, "GMX": {}, "SAFE": {}, "USDP": {}, "WETH": {}, "PEPE": {}, "CBETH": {}, "SFRXETH": {}, "FRXETH": {} }
      console.log("Prefetching bundled registry tokens")
      setList(preloadedRegistry)
    // }
  }, [])

  useEffect(() => {
    if (isInPortfolioView) {
      const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          console.log('Tab is now in view!');
          // Put your callback logic here
          // setFavoritesArray(useSelector((state) => state.favoritesArray))
          // favoritesArray = useSelector((state) => state.favoritesArray);
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);

      return () => {
        // Remove the event listener on cleanup
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    }
  }, []); // Empty dependency array means this effect runs once on mount and cleanup on unmount

  useBottomScrollListener(() => {
    const tokenArray = Object.keys(list)
    const total = (page + 1) * 100
    if ((total < tokenArray.length) && (listViewState == 'list')) {
      setPage(page + 1)
    }
  });

  const { data, isSuccess, isError, isLoading, isFetching } = useContractRead({
    address: resolverAddress,
    abi: resolverAbi,
    functionName: 'contenthash',
    args: ['0xfdff372b2c0d1cf0c13edf11f4bb394150b609a338592bdaa5fde959522bf5df'], // (registry.tkn.eth)
    cacheTime: 3600_000, // 1 Hr
    onSuccess(data) {
      console.log('Successfully fecthed token registry data', data)
      let tickerListCid = decode(data);
      getList(tickerListCid);
    },
  })

  useContractRead({
    address: resolverAddress,
    abi: resolverAbi,
    functionName: 'contenthash',
    args: ['0x3d827df347abb6fe19e620d6af8b3ef9b2da5c0cc1923799168accc73920b477'], // (search.assets.tkn.eth)
    cacheTime: 3600_000, // 1 Hr
    onSuccess(data) {
      console.log('Successfully fecthed token search media', data)
      let searchMediaCid = decode(data);
      getSearchMedia(searchMediaCid);
    },
  })

  let stickyElem = document.getElementsByClassName("data-header")
  let tableDiv = document.getElementsByClassName("data-table")

  if (stickyElem.length > 0) {
    let tableYOffset = tableDiv[0].offsetTop
    let sizeData = []
    for (let i = 0; i < stickyElem.length; i++) {
      sizeData[i] = {}
      sizeData[i]['intendedWidth'] = stickyElem[i].getBoundingClientRect().width;
      sizeData[i]['intendedHeight'] = stickyElem[i].getBoundingClientRect().height;
    }
    window.onscroll = function() {
      for (let i = 0; i < stickyElem.length; i++) {
        if(window.pageYOffset > tableYOffset) {
          stickyElem[i].style.position = "relative";
          stickyElem[i].style.top = (window.pageYOffset - tableYOffset)+"px";
          stickyElem[i].style.width = stickyElem[i].getBoundingClientRect().width + "px";
          stickyElem[i].style.height = stickyElem[i].getBoundingClientRect().height + "px";
        } else {
          stickyElem[i].style.position = "relative";
          stickyElem[i].style.top = "initial";
        }
      }
    };
  }

  // console.log("Favorites:", favoritesArray)

  // Detect Safari
  let safariAgent = 
  navigator.userAgent.indexOf("Safari") > -1;
    
// Discard Safari since it also matches Chrome
  if ((navigator.userAgent.indexOf("Chrome")) && (safariAgent)) 
  safariAgent = false;

  return <>


    <MediaStyle>
    <div className={`${detailLevel === "simple" && !isInEditMode ? 'token-table-container' : ''} px-4 sm:px-6 lg:px-8`} >
      <SearchForm filteredTokens={filteredTokens} setSearchString={setSearchString} setListViewState={setListViewState} setShowHero={setShowHero} shouldFocus={isInSearchUrl} providedSearchString={query} />

      {isInEditMode && 
        <div className="mb-5 sm:mb-4 ml-0 sm:ml-6  mt-3 flex items-center">
          <div className="flex-auto">
            <h1 className="text-xl ml-0 sm:ml-4 font-semibold text-gray-900 text-left">Edit Dataset</h1>
            <p className="mt-2 ml-0 sm:ml-4 text-sm text-gray-700 text-left">
              Improve the TKN dataset by submitting updates
            </p>
          </div>
          <div className="mt-4 ml-16 flex-none">
            <button
              onClick={() => { setEditNewToken(true) }}
              type="button"
              style={{ backgroundColor: primaryCTAButtonColor, fontWeight: primaryCTAFontWeight }}
              className={`mr-0 sm:mr-11 inline-flex items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 w-auto`}
            >
                {/* <PlusIcon className='mr-2'/> */}
              Add Token
            </button>
          </div>
        </div>
      }

      <div className="flex flex-col ">
        {/* {shouldShowLoading && (<>
          I will dissappear when all the loading state is gone
        </>)}
        {(listViewState == "search") && filteredTokens.length == 0 && searchString.length > 0 && 
          <>
            No results for {searchString}. Consider submitting a new token   
            <Link to={`/edit`}>
              Add Token
            </Link>
          </>
        } */}

        {(listViewState == "search") && filteredTokens.length == 0 && searchString.length > 0 &&
          <InstructionDetail text={`No matches for ${searchString}. Consider submitting a new token.`} />
        }
        {(listViewState == "portfolio") && favoritesArray.length == 0 && searchString.length == 0 &&
          <InstructionDetail text={"No tokens favorited. \nStar some of your favorite tokens."} />
        }
                    
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="flex flex-col inline-block min-w-full pt-2 md:pt-4 py-2 align-middle md:px-6 lg:px-8 md:pb-6 lg:pb-8">
            <div className={`bg-white flex-grow overflow-auto shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg rounded-child-responsive ${isInEditMode && "edit-mode-table-parent"}`}>
            <div style={{overflow: 'hidden'}} className="sm:rounded-lg">
            <div className="overflow-x-auto">
              <table className={`data-table relative min-w-full divide-y divide-gray-300 sm:rounded-t-lg rounded-child-responsive ${isInEditMode && "edit-mode-table"}`}>
                <thead className='bg-gray-50 sm:rounded-t-lg p-1'>
                  <tr>
                    <th
                      scope="col"
                      className="data-header top-0 py-3.5 pl-5 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 bg-white sm:rounded-tl-lg"
                    >
                      Logo
                      <div className='table-header-border'></div>
                    </th>
                    <th scope="col" style={{ zIndex: '1 !important', paddingLeft: '0.7rem', width: '80px' }} className="text-left data-header top-0 py-3.5 pr-2 text-sm font-semibold text-gray-900 bg-white" >
                      Ticker
                      <div className='table-header-border'></div>
                    </th>
                    {isInEditMode && <>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Name
                        <div className='table-header-border'></div>
                      </th>
                    </>}
                    {!isInEditMode && <>
                      <th scope="col" className="text-right data-header top-0 py-3.5 pr-3 pl-2 text-sm font-semibold text-gray-900 bg-white">
                        Price
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="text-left data-header top-0 py-3.5 px-3 text-sm font-semibold text-gray-900 bg-white">
                        24H
                        <div className='table-header-border'></div>
                      </th>
                    </>}
                    <th scope="col" className="data-header desc top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                      Description
                      <div className='table-header-border'></div>
                    </th>
                    {(detailLevel === "expanded" || isInEditMode) && <>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        URL
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Contract Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Token Decimals
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className={`data-header top-0 py-3.5 px-3 text-sm font-semibold text-gray-900 bg-white ${isInEditMode ? 'text-left' : ''}`}>
                        Twitter
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className={`data-header top-0 py-3.5 px-3 text-sm font-semibold text-gray-900 bg-white ${isInEditMode ? 'text-left' : ''}`}>
                        Github
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className={`data-header top-0 py-3.5 px-3 text-sm font-semibold text-gray-900 bg-white ${isInEditMode ? 'text-left' : ''}`}>
                        DWebsite
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Version Number
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Optimism{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Arbitrum{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Polygon{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        BSC{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Base{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Fantom{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Avalanche{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Gnosis{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Solana{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Tron{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        NEAR{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Cronos{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Zilliqa{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Goerli{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                      <th scope="col" className="data-header top-0 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 bg-white">
                        Sepolia{"\n"}Address
                        <div className='table-header-border'></div>
                      </th>
                    </>}
                    {!isInEditMode && <>
                      <th scope="col" className="data-header relative py-3.5 pl-3 pr-4 sm:pr-6 md:pr-0 bg-white">
                        <span className="sr-only">Edit</span>
                        <div className='table-header-border'></div>
                      </th>
                    </>}
                  </tr>
                </thead>

                { /* Render Rows with token data */ }
                <tbody className="divide-y divide-gray-200">
                  {!isSuccess && !editSearchPath && (<>
                    <PlaceholderCell />
                  </>)}
                  {isSuccess && ( <>
                    {/* TODO: Integrate edit into listViewState */}
                    {editNewToken &&
                      <TokenCell newToken={true} key={"newtoken"} ticker={"NEWTOKEN"} editMode={isInEditMode} handleDataInput={handleDataInput} detailLevel={detailLevel} openConnectModal={openConnectModal} setSelectedView={setSelectedView} />
                    }
                    {/* {(listViewState == "search") && filteredTokens.length == 0 && searchString.length > 0 &&
                      <InstructionRow text={`No matches for ${searchString}. Consider submitting a new token`} />
                    } */}
                    {(listViewState == "search" && !editSearchPath) && filteredTokens.length == 0 && searchString.length == 0 &&
                      <PlaceholderCell thing={getPaginatedTokenList}/>
                    }
                    {(listViewState == "search" || editSearchPath) && filteredTokens.map((t, index) => (
                      <TokenCell key={t} ticker={t} editMode={isInEditMode} handleDataInput={handleDataInput} detailLevel={detailLevel} openConnectModal={openConnectModal} setSelectedView={setSelectedView} price={prices[t]} />
                    ))}

                    {(listViewState == 'list' && !editSearchPath) && getPaginatedTokenList().tokens.map(t =>
                      <TokenCell key={t} ticker={t} editMode={isInEditMode} handleDataInput={handleDataInput} detailLevel={detailLevel} openConnectModal={openConnectModal} setSelectedView={setSelectedView} price={prices[t]} />
                    )}
                    {(listViewState == 'list' && !editSearchPath) && !getPaginatedTokenList().finished &&
                      <PlaceholderCell thing={getPaginatedTokenList}/>
                    }
                    {/* {(listViewState == "portfolio") && favoritesArray.length == 0 && searchString.length == 0 &&
                      <InstructionRow text={"No tokens saved, star some of your favorite tokens."} />
                    } */}
                    {(listViewState == "portfolio") && favoritesArray.map((t, index) => (
                      <TokenCell key={t} ticker={t} editMode={isInEditMode} handleDataInput={handleDataInput} detailLevel={detailLevel} openConnectModal={openConnectModal} setSelectedView={setSelectedView} price={prices[t]} />
                    ))}
                  </>)}
                  {/* {true && (
                    <>
                      <PlaceholderCell />
                      <PlaceholderCell />
                      <PlaceholderCell />
                      <PlaceholderCell />
                      <PlaceholderCell />
                      <PlaceholderCell />
                    </>
                  )} */}
                </tbody>
              </table>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </MediaStyle>
  </>
  // else return <>Loading</>
}

export function PlaceholderCell({ thing }) {
  // console.log("shouldPlacehodler", thing)
  return (
    <>
      <tr key={"placeholder"} className='main-token-tr'>
        <td className="whitespace-nowrap py-4 pl-6 pr-3 text-sm font-medium text-gray-900 sm:pl-6 md:pl-6">
        <svg width="35" height="35" viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg">
          <circle cx="17.5" cy="17.5" r="17.5" fill="#f0f0f0" />
        </svg>
        </td>
        <td className="text-left horizontal-sticky-header whitespace-nowrap py-4 pr-2 text-sm text-gray-500 font-semibold" style={{ paddingLeft: "0.7rem", maxWidth: '105px', whiteSpace: 'break-spaces' }}>
          <div className="font-bold"><TextLoadingIndicator /></div>
        </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
        <td className="py-4 px-4 text-sm text-gray-500 font-semibold"> <TextLoadingIndicator /> </td>
      </tr>
    </>
  )
}

function InstructionDetail({ text }) {
  return (<>
    <div className='mt-1 font-semibold mb-6 px-2.5'>{text}</div>
  </>)
}

function InstructionRow({ text }) {
  return (<>
    <tr>
      <td colSpan="6" >
        <div style={{

        }}>{text}</div>
      </td>
    </tr>
  </>)
}

function TokenCell({ newToken, ticker, detailLevel, editMode, handleDataInput, openConnectModal, setSelectedView, price }) {
  const { isConnected } = useAccount()
  const [token, setToken] = useState({})
  // const [showDetailView, setShowDetailView] = useState(false);

  let tnsDomain = `${ticker.toLowerCase()}.tkn.eth`
  let hashedTnsDomain = namehash.hash(tnsDomain)

  const { data: tokenData, isSuccess, isFetching } = useContractRead({
    address: tknHelperAddress,
    abi: tknHelperAbi,
    functionName: 'dataFor',
    cacheTime: 3600_000, // 1 Hr
    args: [ticker.toLowerCase()],
  })

  // if (tokenData) {
  //   console.log("Fetched data for", ticker)
  // }

  // const handleDetailViewOpen = () => {
  //   setShowDetailView(true);
  // };  

  const handleDataChange = (e, type) => {
    updateSubmissionBuffer(e.target.value, type)
  }

  const handleAvatarChange = (cid) => {
    updateSubmissionBuffer(cid, "avatar")
  }

  const updateSubmissionBuffer = (data, type) => {
    token[type] = data
    const mutableData = editedDataObject;
    mutableData[Object.keys({ [ticker]: token })] = token;
    pendingEdits = true
    editedDataObject = mutableData
    console.log(editedDataObject)
  }

    // Token Table view in edit mode with new token row
  if (newToken && editMode) return (
    <>
      <tr>
        <TokenLogoEditCell
          newToken={true}
          tokenData={tokenData}
          handleAvatarChange={handleAvatarChange} />
        <td className='horizontal-sticky-header'><input type="text" style={{ textTransform: 'uppercase', width: '100px' }} defaultValue={""} onChange={(e) => { handleDataChange(e, "ticker") }} placeholder={newToken && "TKN"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "name") }} placeholder={"Token Name"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "description") }} placeholder={"Token Description"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "url") }} placeholder={"Project Website"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "contractAddress") }} placeholder={"Mainnet Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "decimals") }} placeholder={"Contract Decimals"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "com.twitter") }} placeholder={"Twitter Handle"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "com.github") }} placeholder={"Github Organization"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "dweb") }} placeholder={"IPFS CID Hash"} /></td>
        <td className='text-gray-500'>{"0.0.1"}</td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "op_address") }}  placeholder={"Optimism Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "arb1_address") }}  placeholder={"Arbitrum Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "matic_address") }}  placeholder={"Polygon Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "bsc_address") }}  placeholder={"BSC Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "base_address") }}  placeholder={"Base Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "ftm_address") }}  placeholder={"Fantom Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "avaxc_address") }}  placeholder={"AVAX Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "gno_address") }}  placeholder={"Gnosis Chain Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "sol_address") }}  placeholder={"Solana Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "trx_address") }}  placeholder={"Tron Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "near_address") }}  placeholder={"NEAR Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "cro_address") }}  placeholder={"Cronos Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "zil_address") }}  placeholder={"Zilliqa Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "goerli_address") }}  placeholder={"Sepolia Contract"} /></td>
        <td><input type="text" defaultValue={""} onChange={(e) => { handleDataChange(e, "sepolia_address") }} placeholder={"Sepolia Contract"} /></td>
      </tr>
    </>
  )

  // Token Table view in edit mode
  if (isSuccess && editMode) return (
    <>
      <tr>
        <TokenLogoEditCell
          tokenData={tokenData}
          handleAvatarChange={handleAvatarChange} />
        {/* <td className=' hover:bg-gray-300' onClick={handleLogoUpload}><img src={tokenData[3]} width="35px" style={{borderRadius: '8px'}}/><PencilIcon className="ml-10 h-5 w-5 -mt-7 mb-2" aria-hidden="true" /></td> */}
        <td className='horizontal-sticky-header' style={{ left: '1px'}}><input type="text" style={{ textTransform: 'uppercase', width: '100px' }} defaultValue={ticker} onChange={(e) => { handleDataChange(e, "ticker") }} /></td>
        <td><input type="text" defaultValue={tokenData[1]} onChange={(e) => { handleDataChange(e, "name") }} /></td>
        <td><input type="text" defaultValue={tokenData[4]} onChange={(e) => { handleDataChange(e, "description") }} placeholder={"Token Description"} /></td>
        <td><input type="text" defaultValue={tokenData.url} onChange={(e) => { handleDataChange(e, "url") }} placeholder={"Project Website"} /></td>
        <td><input type="text" defaultValue={tokenData.contractAddress === '0x0000000000000000000000000000000000000000' ? "" : tokenData.contractAddress} onChange={(e) => { handleDataChange(e, "contractAddress") }} /></td>
        <td><input type="text" defaultValue={tokenData.decimals} onChange={(e) => { handleDataChange(e, "decimals") }} placeholder={"Contract Decimals"} /></td>
        <td><input type="text" defaultValue={tokenData.twitter} onChange={(e) => { handleDataChange(e, "com.twitter") }} placeholder={"Twitter Handle"} /></td>
        <td><input type="text" defaultValue={tokenData.github} onChange={(e) => { handleDataChange(e, "com.github") }} placeholder={"Github Organization"} /></td>
        <td><input type="text" defaultValue={tokenData.dweb === '0x' ? "" : decode(tokenData.dweb)} onChange={(e) => { handleDataChange(e, "dweb") }} placeholder={"IPFS CID Hash"} /></td>
        <td className='text-gray-500'>{tokenData.version}</td>
        <td><input type="text" defaultValue={tokenData.op_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.op_address} onChange={(e) => { handleDataChange(e, "op_address") }} placeholder={"Optimism Contract"} /></td>
        <td><input type="text" defaultValue={tokenData.arb1_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.arb1_address} onChange={(e) => { handleDataChange(e, "arb1_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.matic_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.matic_address} onChange={(e) => { handleDataChange(e, "matic_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.bsc_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.bsc_address} onChange={(e) => { handleDataChange(e, "bsc_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.base_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.base_address} onChange={(e) => { handleDataChange(e, "base_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.ftm_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.ftm_address} onChange={(e) => { handleDataChange(e, "ftm_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.avaxc_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.avaxc_address} onChange={(e) => { handleDataChange(e, "avaxc_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.gno_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.gno_address} onChange={(e) => { handleDataChange(e, "gno_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.sol_address === '0x' ? "" : addressEncoder.formatsByName['SOL'].encoder(Buffer.from(tokenData.sol_address.substring(2), 'hex'))} onChange={(e) => { handleDataChange(e, "sol_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.trx_address === '0x' ? "" : addressEncoder.formatsByName['TRX'].encoder(Buffer.from(tokenData.trx_address.substring(2), 'hex'))} onChange={(e) => { handleDataChange(e, "trx_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.near_address === '0x' ? "" : addressEncoder.formatsByName['NEAR'].encoder(Buffer.from(tokenData.near_address.substring(2), 'hex'))} onChange={(e) => { handleDataChange(e, "near_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.cro_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.cro_address} onChange={(e) => { handleDataChange(e, "cro_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.zil_address === '0x' ? "" : addressEncoder.formatsByName['ZIL'].encoder(Buffer.from(tokenData.zil_address.substring(2), 'hex'))} onChange={(e) => { handleDataChange(e, "zil_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.goerli_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.goerli_address} onChange={(e) => { handleDataChange(e, "goerli_address") }} /></td>
        <td><input type="text" defaultValue={tokenData.sepolia_address === '0x0000000000000000000000000000000000000000' ? "" : tokenData.sepolia_address} onChange={(e) => { handleDataChange(e, "sepolia_address") }} /></td>
        {/* <li key={props.ticker}>{props.ticker}: {tokenData[1]}<br/>{tokenData[4]}</li>  */}
      </tr>
    </>
  )

  // Main Token Table View
  if (isSuccess) return (
    <tr key={ticker} className='main-token-tr'>
      <td className="whitespace-nowrap py-4 pl-6 pr-3 text-sm font-medium text-gray-900 sm:pl-6 md:pl-6">
        {/* {person.name} */}
        <Link to={`/${ticker.toLowerCase()}`}>
          {/* <img src={tokenData[3]} width="35px" style={{ borderRadius: '8px' }} alt="" /> */}
          <ImageFromIPFS src={tokenData[3]} width="35px" style={{ borderRadius: '8px' }} alt="" />
        </Link>
      </td>
      <td className="text-left horizontal-sticky-header whitespace-nowrap py-4 pr-2 text-sm text-gray-500 font-semibold" style={{ paddingLeft: "0.7rem", maxWidth: '105px', whiteSpace: 'break-spaces' }}>
        <Link to={`/${ticker.toLowerCase()}`}>
          <p className="font-bold">{ticker}</p><p>{tokenData[1]}</p>
        </Link>
      </td>
      {/* <td className="break-words whitespace-nowrap py-4 px-3 text-sm text-gray-500" style={{ maxWidth: '120px', whiteSpace: 'break-spaces' }}>{tokenData[1]}</td> */}
      <PriceDataCells ticker={ticker} price={price}/>
      <td className="break-words whitespace-nowrap py-4 px-3 text-left text-sm text-gray-500" style={{ minWidth: '180px', whiteSpace: 'break-spaces' }}><Link to={`/${ticker.toLowerCase()}`}>{tokenData[4]}</Link></td>
      {detailLevel === "expanded" && <>
        <td className="whitespace-nowrap py-4 px-3 text-left text-sm text-gray-500"><a href={tokenData.url} target="_blank">{tokenData.url.replace(/^https?:\/\//, '').replace("www.", "")}</a></td>
        {tokenData.contractAddress === '0x0000000000000000000000000000000000000000' ? (
          <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left">No Contract</td>
        ) : (
          <td className="whitespace-nowrap py-4 px-3 text-left text-sm text-gray-500"><a href={'https://etherscan.io/address/' + tokenData.contractAddress} target="_blank">{tokenData.contractAddress}</a></td>
        )
        }
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500"><Link to={`/${ticker.toLowerCase()}`}>{tokenData.decimals}</Link></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500"><a href={'https://twitter.com/' + tokenData.twitter} target="_blank">{tokenData.twitter}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500"><a href={'https://github.com/' + tokenData.github} target="_blank">{tokenData.github}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500"><a href={'https://'+ticker.toLowerCase()+'.tkn.eth.limo' } target="_blank">{tokenData.dweb!= '0x' ? ""+ticker.toLowerCase()+".tkn.eth.limo" : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500"><Link to={`/${ticker.toLowerCase()}`}>{tokenData.version}</Link></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.op_address != 0x0000000000000000000000000000000000000000 ? 'https://optimistic.etherscan.io/address/'+tokenData.op_address : ''} target="_blank">{tokenData.op_address != 0x0000000000000000000000000000000000000000 ? tokenData.op_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.arb1_address != 0x0000000000000000000000000000000000000000 ? 'https://arbiscan.io/address/'+tokenData.arb1_address : ''} target="_blank">{tokenData.arb1_address != 0x0000000000000000000000000000000000000000 ? tokenData.arb1_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.matic_address != 0x0000000000000000000000000000000000000000 ? 'https://polygonscan.com/address/'+tokenData.matic_address : ''} target="_blank">{tokenData.matic_address != 0x0000000000000000000000000000000000000000 ? tokenData.matic_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.bsc_address != 0x0000000000000000000000000000000000000000 ? 'https://bscscan.com/address/'+tokenData.bsc_address : ''} target="_blank">{tokenData.bsc_address != 0x0000000000000000000000000000000000000000 ? tokenData.bsc_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.base_address != 0x0000000000000000000000000000000000000000 ? 'https://basescan.org/address/'+tokenData.base_address : ''} target="_blank">{tokenData.base_address != 0x0000000000000000000000000000000000000000 ? tokenData.base_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.ftm_address != 0x0000000000000000000000000000000000000000 ? 'https://ftmscan.com/address/'+tokenData.ftm_address : ''} target="_blank">{tokenData.ftm_address != 0x0000000000000000000000000000000000000000 ? tokenData.ftm_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.avaxc_address != 0x0000000000000000000000000000000000000000 ? 'https://snowtrace.io/token/'+tokenData.avaxc_address : ''} target="_blank">{tokenData.avaxc_address != 0x0000000000000000000000000000000000000000 ? tokenData.avaxc_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.gno_address != 0x0000000000000000000000000000000000000000 ? 'https://gnosisscan.io/address/'+tokenData.gno_address : ''} target="_blank">{tokenData.gno_address != 0x0000000000000000000000000000000000000000 ? tokenData.gno_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={'https://explorer.solana.com/address/'+addressEncoder.formatsByName['SOL'].encoder(Buffer.from(tokenData.sol_address.substring(2), 'hex')) } target="_blank">{tokenData.sol_address != '0x' ? addressEncoder.formatsByName['SOL'].encoder(Buffer.from(tokenData.sol_address.substring(2), 'hex')) : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={'https://tronscan.org/#/contract/'+addressEncoder.formatsByName['TRX'].encoder(Buffer.from(tokenData.trx_address.substring(2), 'hex')) } target="_blank">{tokenData.trx_address != '0x' ? addressEncoder.formatsByName['TRX'].encoder(Buffer.from(tokenData.trx_address.substring(2), 'hex')) : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.near_address != '0x' ? 'https://explorer.near.org/accounts/'+addressEncoder.formatsByName['NEAR'].encoder(Buffer.from(tokenData.near_address.substring(2), 'hex')) : ''} target="_blank">{tokenData.near_address != '0x' ? addressEncoder.formatsByName['NEAR'].encoder(Buffer.from(tokenData.near_address.substring(2), 'hex')) : ''}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.cro_address != 0x0000000000000000000000000000000000000000 ? 'https://cronoscan.com/address/'+tokenData.cro_address : ''} target="_blank">{tokenData.cro_address != 0x0000000000000000000000000000000000000000 ? tokenData.cro_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.zil_address != '0x' ? 'https://viewblock.io/zilliqa/address/'+addressEncoder.formatsByName['ZIL'].encoder(Buffer.from(tokenData.zil_address.substring(2), 'hex')) : ''} target="_blank">{tokenData.zil_address != '0x' ? addressEncoder.formatsByName['ZIL'].encoder(Buffer.from(tokenData.zil_address.substring(2), 'hex')) : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.goerli_address != 0x0000000000000000000000000000000000000000 ? 'https://goerli.etherscan.io/address/'+tokenData.goerli_address : ''} target="_blank">{tokenData.goerli_address != 0x0000000000000000000000000000000000000000 ? tokenData.goerli_address : ""}</a></td>
        <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500 text-left"><a href={tokenData.sepolia_address != 0x0000000000000000000000000000000000000000 ? 'https://sepolia.etherscan.io/address/'+tokenData.sepolia_address : ''} target="_blank">{tokenData.sepolia_address != 0x0000000000000000000000000000000000000000 ? tokenData.sepolia_address : ""}</a></td>
      </>}
      <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 md:pr-6">
        <Link to={`/edit/${ticker.toLowerCase()}`} /* onClick={() => isConnected ? setSelectedView("editTokens") : openConnectModal(true)} */ className="text-indigo-600 hover:text-indigo-900 cursor-pointer">
          Edit<span className="sr-only">, {ticker}</span>
        </Link>
      </td>
    </tr>
  )
}

const TextLoadingIndicator = ({ width, height }) => {
  const style = {
    width: width || '100%',
    height: height || '1em',
  };

  return <div className="text-loading-indicator" style={style}></div>;
};

function TokenLogoEditCell({ newToken, tokenData, handleAvatarChange }) {
  let startingImage = newToken ? null : tokenData[3]
  const [isNewToken, setIsNewToken] = useState(newToken)
  const [logoUrl, setLogoUrl] = useState(startingImage)
  const [logoWidth, setLogoWidth] = useState("35px")

  const uploadAndPinLogo = async (e) => {
    if (e.target.parentElement.firstChild.getElementsByTagName('INPUT')[0]) {
      e.target.parentElement.firstChild.getElementsByTagName('INPUT')[0].click()
    } else {
      e.target.parentElement.getElementsByTagName('INPUT')[0].click()
    }
  }

  async function onChange(e) {
    const file = e.target.files[0]
    // const file = e.dispatchEvent(new Event('input', {bubbles:true}));
    try {
      console.log("Uploading file", file)
      const added = await client.add(file)
      // const added = await client.add('{"test":"test"}')
      const url = `https://tkn.infura-ipfs.io/ipfs/${added.path}`
      // const url = `https://ipfs.io/ipfs/${added.path}`
      console.log('File uploaded to', url)
      // updateFileUrl(url)

      // const instance = await web3Modal.connect();

      // const provider = new ethers.providers.Web3Provider(instance);
      // const signer = provider.getSigner();

      setIsNewToken(false)
      setLogoUrl(url)
      // setLogoWidth("140px")
      // setOffsetPencil(true)
      handleAvatarChange(added.path)
      
    } catch (error) {
      console.log('Error uploading file: ', error)
    }
  }

  return (
    <td className='cursor-pointer hover:bg-gray-300' onClick={uploadAndPinLogo} style={{ position: 'relative', height: '52px' }}>
      {!isNewToken &&
        <img alt="Upload Icon" className="mr-10" src={logoUrl} width={logoWidth} style={{ borderRadius: '8px' }} />
      }
      <PencilIcon className={` ml-5 ${isNewToken ? '-mt-2.5' : '-mt-4'} h-5 w-5 mb-2 bg-grey rounded-md`} style={{ backgroundColor: 'lightgray', padding: '2px', position: 'absolute'}} aria-hidden="true" />
      <input
        className='hidden'
        type="file"
        onChange={onChange}
      /></td>
  )
}

function SubmissionList(props) {
 



  // const { data: submissions, error } = useContractRead(
  //   contractConfig,
  //   'getDescSubmissionsAtPage',
  //   {
  //     args: "0",
  //     // cacheTime: 20000, // Cache for one day
  //   },
  //   { watch: true, }
  // );
  // const { chains } = chain()
  // console.log("is connected", isConnected, submissions, chain)
  // console.log(error)


  return (
    <SubmissionTable />
    // sm.reverse().map((s) => 
    //   <li>Status: {SubmissionStates[s[2]]},<br/>Submitter: {s[1]}<br/>Eth Staked: {ethers.utils.formatEther ( s[3] )}<br/><SubmissionData cid = {s[0]}/></li>
    // );
  )
}

const SubmissionStatus = {
  0: "Submitted",
  1: "Accepted",
  2: "Merged",
  3: "Rejected",
  4: "Spam"
}

export function SubmissionTable(props) {
  return (
    <div className="px-4 sm:px-6 lg:px-8 mt-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl ml-4 font-semibold text-gray-900 text-left">Data Submissions</h1>
          <p className="mt-2 ml-4 text-sm text-gray-700 text-left">
            Community submitted updates to the TKN dataset
          </p>
          <p className="mt-2 ml-4 text-sm text-gray-700 text-left">Submission statuses: <b>Submitted, Accepted, Merged, Rejected, or Spam</b></p>
        </div>
        {/* <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
          >
            Add user
          </button>
        </div> */}
      </div>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3  text-sm font-semibold text-gray-900 sm:pl-6">
                      Status
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-sm font-semibold text-gray-900">
                      Data
                    </th>
                    <th scope="col" className="px-3 py-3.5  text-sm font-semibold text-gray-900">
                      Submitter
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-sm font-semibold text-gray-900">
                      ETH Staked
                    </th>
                    {/* <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Data
                    </th> */}

                    {/* <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                      <span className="sr-only">Edit</span>
                    </th> */}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  <SubmissionTableRows page={0} />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const SubmissionTableRows = ({ page }) => {
  const { isConnected } = useConnect()
  const { account } = useAccount()

  const { data: submissions, isError, isLoading } = useContractRead({
    address: submitterAddr,
    abi: submitterAbi,
    functionName: 'getDescSubmissionsAtPage',
    args: page.toString(),
  })
  // return (<tr></tr>)
  if (submissions) {
    var sm = JSON.parse(JSON.stringify(submissions));

    return (
      // if(submissions) {
      <>
      {sm.slice(0).reverse().map((submission) => (
        <>
        <tr key={submission.email}>
          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
            {SubmissionStatus[submission[2]]}
          </td>
          <td className="max-w-sm px-3 py-4 text-sm text-gray-500">{<SubmissionData cid={submission[0]} />}</td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500"><a href={'https://etherscan.io/address/' + submission[1]} target="_blank">{submission[1]}</a></td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{ethers.utils.formatEther(submission[3])}</td>
        </tr>
        </>
      ))}
      {page <= 5 && // Show five pages of submissions for now (25), TODO: Add pagination
        <SubmissionTableRows page={page + 1}/>
      }
      </>
      
    )
  }
}

function SubmissionData(props) {
  const [data, setData] = useState('')

  useEffect(() => {
    getData(props.cid);
  }, [])


  const getData = async (cid) => {
    let response = await axios.get(`https://tkn.infura-ipfs.io/ipfs/${cid}`)
    setData(response.data)
    // return response.data;

    // // const resp = await client.cat(cid);
    // let content = [];
    // for await (const chunk of resp) {
    //   content = [...content, ...chunk];
    // }
    // // console.log(content.toString());
    // const raw = Buffer.from(content).toString('utf8')
    // setData(raw)
  }

  return (
    <p className="break-words"><code>{JSON.stringify(data)}</code></p>
  )
}

// import { useConnectModal } from '@rainbow-me/rainbowkit';
function EditButton({ setSelectedView, loggedInAddress, openConnectModal }) {
  function activateEditing(e) {
    setSelectedView("editTokens")
  }
  function connectAccount(e) {
    openConnectModal(true)
  }
  return <>
    {/* <button
      type="button"
      onClick={loggedInAddress ? activateEditing : connectAccount}
      className="inline-flex items-center px-6 py-3 border border-transparent text-base font-large rounded-full shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      style={{ zIndex: 10, padding: '15px 32px', margin: '4px 2px', cursor: 'pointer', position: 'fixed', bottom: '26px', left: '28px' }}>
      <MagnifyingGlassIcon className="-ml-1 mr-3 h-5 w-5" aria-hidden="true" />
      Search
    </button> */}

    <Link to="/edit">
      <button
        type="button"
        onClick={loggedInAddress ? activateEditing : connectAccount}
        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-large rounded-full shadow-sm text-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400"
        style={{ zIndex: 10, padding: '15px 32px', margin: '4px 2px', cursor: 'pointer', position: 'fixed', bottom: '26px', right: '28px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: primaryCTAButtonColor, fontWeight: primaryCTAFontWeight}}>
        <PencilSquareIcon className="-ml-1 mr-3 h-5 w-5" aria-hidden="true" />
        Edit Data
        {/* <EnvelopeIcon className="ml-3 -mr-1 h-5 w-5" aria-hidden="true" /> */}
      </button>
    </Link>
    {/* <LoginPromptModal openModal={}/> */}
  </>
}

function SubmissionController({ dataChanged, setSelectedView, setIsModalLoginPromptOpen }) {
  const [aggregatedSubmissionData, setAggregatedSubmissionData] = useState({})
  const [isShowingSubmissionModal, showSubmissionModal] = useState(false)
  const [submissionError, setSubmissionError] = useState()

  const { address, isConnecting, isDisconnected } = useAccount()
  // console.log(props)

  const processDataChange = () => {
    if (pendingEdits) {
      // setAggregatedSubmissionData(editedDataObject)
      document.getElementById('submissionDataInputField').value = JSON.stringify(editedDataObject)
      pendingEdits = false
      console.log(editedDataObject, '- Has changed')
    }
  }

  const submitSubmission = useContractWrite(
    {
      addressOrName: submitterAddr,
      contractInterface: submitterAbi,
    },
    'createSubmission',
  )

  useEffect(() => {
    // if (Object.keys(dataChanged).length > 0) {
    //   const timer = setTimeout(() => {
    //     processDataChange(dataChanged)
    //   }, 1000);
    //   // setTimeout(processDataChange(dataChanged), 1000)

    //   console.log("useEffect aggregatedSubmissionData", aggregatedSubmissionData)
    // }

  }) // <-- here put the parameter to listen

  setInterval(() => {
    processDataChange()
  }, 1000);

  const { preparedSubmissionWrite } = usePrepareContractWrite({
    address: submitterAddr,
    abi: submitterAbi,
    functionName: 'createSubmission',
    args: ["dddd"]
  })
  const { dataB, isLoading, isSuccess, writeB } = useContractWrite(preparedSubmissionWrite)

  const contractWriteB = useContractWrite({
    mode: 'recklesslyUnprepared',
    address: submitterAddr,
    abi: submitterAbi,
    functionName: 'createSubmission',
    onError(data, error) {
      console.log('Settled', { data, error })
      // if (data) {
        setSubmissionError(data)
      // }
      showSubmissionModal(true)
    },
    onSuccess(data, error) {
      console.log('Settled', { data, error })
      setSubmissionError(null)
      showSubmissionModal(true)
    },
  })

  const cancelEditMode = () => {
    setSelectedView("tokens")
    // props.updateView("submissions")
    // props.view = "tokens"
  }

  async function submitNewData(e, contractWriteB) {
    if (!address) {
      console.log("User submitted data without being logged in")
      setIsModalLoginPromptOpen(true)
      return
    }
    console.log("Submit data button clicked")
    const added = await client.add(document.getElementById('submissionDataInputField').value)
    const url = `https://tkn.infura-ipfs.io/ipfs/${added.path}`
    console.log('File uploaded to', url)

    var data = JSON.stringify({
      "hashToPin": added.path,
      "pinataMetadata": {
        "name": added.path
      }
    });

    var config = {
      method: 'post',
      url: 'https://api.pinata.cloud/pinning/pinByHash',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI2YmFjMTI2Ny04ZDk3LTQ0MDktYTE2Ni04OTM1N2Q5ZDkwMTUiLCJlbWFpbCI6ImRpc2NvbmV0d29ya3NAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInBpbl9wb2xpY3kiOnsicmVnaW9ucyI6W3siaWQiOiJOWUMxIiwiZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjF9XSwidmVyc2lvbiI6MX0sIm1mYV9lbmFibGVkIjpmYWxzZSwic3RhdHVzIjoiQUNUSVZFIn0sImF1dGhlbnRpY2F0aW9uVHlwZSI6InNjb3BlZEtleSIsInNjb3BlZEtleUtleSI6IjhiMzFhZDY1Njg3NDdiNzgyZmY4Iiwic2NvcGVkS2V5U2VjcmV0IjoiZWYzNDIxYzU0ODBjZTkyOGJhNjc1YjAxNzFmMDMyYmNiNDdmNGY1YjhjMzc1NzMxOTkxOTczZWJjN2EzMTFhZiIsImlhdCI6MTY2Nzg3NzgxN30.SE1HRBEnZZuZJUgoeyR8A7lcGfe1533nuttx6xzAMDo',
        'Content-Type': 'application/json'
      },
      data: data
    };

    const res = await axios(config);

    contractWriteB.write({
      recklesslySetUnpreparedArgs: [added.path],
      // recklesslySetUnpreparedOverrides: {
      //   from: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
      //   value: ethers.utils.parseEther('0.01'),
      // },
    })

    console.log("aggregatedsubmissiondata", aggregatedSubmissionData, "submitcontractwritedata");
    // updateFileUrl(url)

  }

  return (
    <>
      <SubmissionModal open={isShowingSubmissionModal} setOpen={showSubmissionModal} error={submissionError} />
      <div className='submission-element border-gray-300 bg-gray-100 p-2 rounded-lg backdrop-blur-sm bg-opacity-60' style={{ borderWidth: 'thin', position: 'fixed' }}>
        {/* <p className='block mb-2 mt-2 text-md font-medium text-gray-900 dark:text-white'>Methodology</p>
        <input placeholder='Brief description of the data source' className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'></input> */}
        <p className='block mb-2 mt-2 text-md font-medium text-gray-900 dark:text-white'>Data</p>
        <textarea placeholder='Use the editor above, or paste your own JSON here' id="submissionDataInputField" className='block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500' spellCheck="false" rows="4" cols="50" style={{ color: 'gray' }} ></textarea><br />
        <button style={{ backgroundColor: primaryCTAButtonColor }} className=' hover:bg-blue-700 text-white font-bold py-2 px-4 rounded' onClick={() => submitNewData(contractWriteB, contractWriteB)}>Submit</button>
        {/* <SubmitButton></SubmitButton> */}
        {/* <button disabled={!contractWriteB} onClick={() => contractWriteB?.()}>
          Mint
        </button> */}
        <Link to="/">
          <button 
          style={{ borderColor: primaryCTAButtonColor, color: primaryCTAButtonColor }}
          className="ml-6 bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
            Cancel
          </button>
        </Link>
        <p className='block mb-2 mt-3 text-md font-normal text-gray-400 dark:text-white'>Gas fees will be refunded to sender</p>
      </div>
    </>
  )
}

export function SubmissionModal({ open, setOpen, error }) {
  // const [open, setOpen] = useState(true)

  const successColor = 'bg-green-100 text-green-600';
  const errorColor = 'bg-red-100 text-red-600';

  if (!open) {
    return null
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" show={open} className="relative z-10" onClose={() => setOpen(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                <div>
                  <div className={`mx-auto flex h-12 w-12 items-center justify-center rounded-full ${error ? errorColor : successColor}`}>
                    {error ? (
                        <ExclamationCircleIcon className={`h-6 w-6 ${error ? 'text-red-600' : 'text-green-600'}`} aria-hidden="true" />
                      ) : (
                        <CheckIcon className={`h-6 w-6 ${error ? 'text-red-600' : 'text-green-600'}`} aria-hidden="true" />
                      )}                  </div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                      {error ? 'Error Submitting Data' : 'Data Submission Sent'}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        {error ? `There was an error submitting your data. Please try again.` : 'Thank you for contributing to the community dataset'}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6">
                  <button
                    type="button"
                    style={{ backgroundColor: primaryCTAButtonColor, fontWeight: primaryCTAFontWeight}}
                    className="inline-flex w-full justify-center rounded-md border border-transparent  px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:text-sm"
                    onClick={() => setOpen(false)}
                  >
                    Continue Editing
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}


// function SubmitButton(props) {

//   const contractWriteB = useContractWrite({
//     mode: 'recklesslyUnprepared',
//     address: submitterAddr,
//     abi: submitterAbi,
//     functionName: 'createSubmission',
//     args: ["{testtest:fest}"]
//   })

//   return (
//     <>
//       <button onClick={() => contractWriteB?.write()}>SubmitC</button>
//     </>
//   )
// }

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

export function TokenTitle() {
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl py-12 px-4 text-center sm:px-6 lg:py-16 lg:px-8">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          <span className="block">Token Name Service</span>
          {/* <span className="block">Start your free trial today.</span>  */}
        </h1>
        {/* <p>Crypto's canonical dataset</p> */}
        {/* <div className="mt-8 flex justify-center">
          <div className="inline-flex rounded-md shadow">
            <a
              href="#"
              className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-5 py-3 text-base font-medium text-white hover:bg-indigo-700"
            >
              Get started
            </a>
          </div>
          <div className="ml-3 inline-flex">
            <a
              href="#"
              className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-100 px-5 py-3 text-base font-medium text-indigo-700 hover:bg-indigo-200"
            >
              Learn more
            </a>
          </div>
        </div> */}
      </div>
    </div>
  )
}

function TknBalance({ setShowRainbowAvatar }) {
  const { address: userAddress, isConnecting, isDisconnected } = useAccount()
  const name = 'tkn.tkn.eth'
  const { data: ensAddress } = useEnsAddress({ name })
  const address = name
  const { data: ensAvatar } = useEnsAvatar({ address })
  const { data: tknData, isError, isLoading } = useBalance({
    address: userAddress,
    token: ensAddress,
    chainId: 10,
  })

  const [mainnetBalance, setMainnetBalance] = useState(null);
  const [optimismBalance, setOptimismBalance] = useState(null);
  const [combinedBalance, setCombinedBalance] = useState(null);

  useEffect(() => {
    // The contract addresses
    const mainnetContractAddress = '0x82D09e30d5D682D69B4A5d97C61b7BA651457625';
    const optimismContractAddress = '0x3Eb398fEc5F7327C6b15099a9681d9568ded2e82';

    // The data for balanceOf function
    if (userAddress) {
      const data = '0x70a08231' + userAddress.substr(2).padStart(64, '0');

      // Query RPCs manually due to rainbowkit's multichain limitation
      async function fetchBalance(providerUrl, contractAddress) {
        const response = await axios.post(providerUrl, {
          jsonrpc: '2.0',
          id: 1,
          method: 'eth_call',
          params: [{
            to: contractAddress,
            data: data
          }, 'latest']
        });

        if (response.data.error) {
          throw new Error(response.data.error.message);
        } else {
          const rawBalance = parseInt(response.data.result, 16);  // Raw balance is returned as a hex string
          const balance = rawBalance / Math.pow(10, 18);  // Convert to standard unit by dividing by 10^18
          return balance;
        }
      }

      // Fetch balances and set state
      Promise.all([
        fetchBalance(mainnetProviderUrl, mainnetContractAddress),
        fetchBalance(optimismProviderUrl, optimismContractAddress)
      ]).then(([mainnet, optimism]) => {
        const combined = mainnet + optimism;
        setMainnetBalance(mainnet);
        setOptimismBalance(optimism);
        setCombinedBalance(combined);
        console.log('Mainnet balance:', mainnetBalance);
        console.log('Optimism balance:', optimismBalance);
        console.log('Combined balance:', combinedBalance);
      }).catch(error => console.error('Error:', error));
    } else {
      setMainnetBalance(null);
      setOptimismBalance(null);
      setCombinedBalance(null);
    }
  }, [userAddress, tknData]);

  function formatBalance(balance) {
    if (balance === null || balance === undefined) {
      return balance;
    }
    const parts = balance.toString().split('.');
    parts[0] = Math.round(Number(parts[0])).toLocaleString();  // Round the integer part
    return parts[0];  // Return only the integer part
  }

  const navigateTo = (url) => {
    window.location.href = url;
  }

  if (ensAvatar) {
  // if (true) {
    // const tokenFloat = parseFloat(tknData.formatted)
    // const formattedBalance = tokenFloat.toString();
    console.log("Combined TKN balance:", combinedBalance, "for", userAddress)
    if (combinedBalance) {
      setShowRainbowAvatar(false)
      return (
        <Popover className="relative flex items-center justify-center h-full">
          <Popover.Button>
            <div className="governance-preview flex items-center bg-neutral-100 px-2 py-0 rounded">
            <img src={ensAvatar} className="mr-3 rounded-full" alt="" style={{ width: 40, height: 40 }} />
              <span className="font-semibold">
                {/* {formattedBalance}
                {optimismBalance} */}
                {formatBalance(combinedBalance)}
                {/* {" " + tknData.symbol} */}
              </span>
            </div>
          </Popover.Button>

          <Popover.Overlay className="fixed inset-0 bg-black opacity-30  z-10" />

          <Popover.Panel className="fixed left-1/2 top-[100px] transform translate-x-[-50%] mt-7 z-20 bg-white rounded-xl w-80 border border-gray-300 drop-shadow-sm">
            <div className="grid grid-cols-2 p-2 gap-2">
              <div className="col-span-2 flex justify-center my-7">
                <img src={ensAvatar} className="drop-shadow-lg rounded-full rotate-3d" alt="TKN Logo" style={{ width: 60, height: 60 }} />
              </div>
              <div className='col-span-2'>Your <strong>$TKN</strong> balance: {formatBalance(combinedBalance)}</div>
              <div className='col-span-2 text-neutral-500 '><strong></strong> Balance on Ethereum Mainnet: {formatBalance(mainnetBalance)}</div>
              <div className={`col-span-2 text-neutral-500 ${optimismBalance ? '' : 'mb-4'}`}><strong></strong> Balance on Optimism: {formatBalance(optimismBalance)}</div>
              {((optimismBalance != null) && (optimismBalance !== 0) && (optimismBalance !== "0")) ?
                <a className="col-span-2 text-neutral-500 font-semibold mb-4" href="https://app.optimism.io/bridge/withdraw" target="_blank" rel="noopener noreferrer">
                    <div className='col-span-2 text-neutral-400'>
                        Bridge TKN to Mainnet
                    </div>
                </a>
                : null
              }
            </div>
          </Popover.Panel>
        </Popover>
      );
    } 
    else {
      return (
        <div 
          className="governance-preview flex items-center bg-neutral-100 px-2 py-0 rounded cursor-pointer"
          onClick={() => navigateTo('https://claim.tkn.xyz')}
        >
          <img src={ensAvatar} className="mr-3 rounded-full" alt="TKN Logo" style={{ width: 40, height: 40 }} />
          <span className="font-semibold">
            Claim
            {/* {formattedBalance} */}
            {/* {" " + tknData.symbol} */}
          </span>
        </div>
      );
    }
  }
}

const navigation = [
  { name: 'Documentation', href: 'https://docs.tkn.xyz/developers/querying-the-tns-dataset' },
  // { name: 'Pending Edits', href: '#' },
  // { name: 'Docs', href: '#' },
  // { name: 'Company', href: '#' },
]

export function TokenHeader({ updateView }) {

  const [showRainbowAvatar, setShowRainbowAvatar] = useState(true)
  return (
    <header className="bg-gray-100">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" aria-label="Top">
        <div className="flex w-full items-center justify-between border-b border-white-500 py-6 lg:border-none">
          <div className="flex items-center">
            <Link to="/" className="cursor-pointer text-base font-medium text-neutral-500 hover:text-indigo-50">
                <span className="sr-only">Token Name Service</span>
                <img className="h-7 w-auto" src="/TKN@2x.png" alt="Token Name Service" />
            </Link>
            <div className="items-center ml-10 hidden space-x-8 lg:block mr-4">
              <Popover className="absolute">
                <Popover.Button key={`links`} className="cursor-pointer text-base font-medium text-neutral-500 hover:text-neutral-900 items-center" style={{ height: '24px', width: '24px' }}>
                  {/* <button> */}
                    <Bars3Icon />
                  {/* </button> */}
                </Popover.Button>
                <HamburgerPopoverPanel />
              </Popover>

              {navigation.map((link) => (
                <a key={link.name} href={link.href} style={{ marginLeft: '3.4rem'}} className="text-base font-medium text-neutral-500 hover:text-neutral-800">
                  {link.name}
                </a>
              ))}
              <Link to="/submissions" key={`submissions`} className="cursor-pointer text-base font-medium text-neutral-500 hover:text-neutral-800">
                  View Edits
              </Link>
              <Link to="/portfolio" key={`portfolio`} className="cursor-pointer text-base font-medium text-neutral-500 hover:text-neutral-800">
                  Starred
              </Link>
            </div>
          </div>

          <div className="items-center ml-2 space-x-4 flex">
            {/* <button key={`links`} className="cursor-pointer text-base font-medium text-neutral-500 hover:text-indigo-50" style={{ height: '24px', width: '24px' }}>
              <Bars3Icon />
            </button> */}
            <TknBalance setShowRainbowAvatar={ setShowRainbowAvatar } />
            <ConnectButton showBalance={{ smallScreen: false, largeScreen: true }}  accountStatus={{ smallScreen: showRainbowAvatar ? "full" : "address", largeScreen: 'full', }}/>
          </div>
        </div>
        <div className="flex flex-wrap justify-center space-x-6 py-4 lg:hidden mt-2">
          {navigation.map((link) => (
            <a key={link.name} href={link.href} className="text-base font-medium text-neutral-500 hover:text-neutral-800">
              {link.name}
            </a>
          ))}
          <Link to="/submissions" key={`submissions`} className="text-base font-medium text-neutral-500 hover:text-neutral-800">
            View Edits
          </Link>
          <Link to="/portfolio" key={`portfolio`} className="text-base font-medium text-neutral-500 hover:text-neutral-800">
            Starred
          </Link>
          <Popover className="relative">
            <Popover.Button key={`links`} className="align-middle cursor-pointer text-base font-medium text-neutral-500 hover:text-neutral-900" style={{ height: '24px', width: '24px', position: 'relative', top: '-1px' }}>
              {/* <button key={`links`} className="align-middle cursor-pointer text-base font-medium text-neutral-500 hover:text-neutral-900" style={{ height: '24px', width: '24px', position: 'relative', top: '-1px' }}> */}
                <Bars3Icon />
              {/* </button> */}
            </Popover.Button>
            <HamburgerPopoverPanel rightOriented={true} />
          </Popover>
        </div>
      </nav>
    </header>
  )
}

function HamburgerPopoverPanel({ rightOriented }) {
  return (
    <Transition
      enter="transition-opacity duration-200 ease-out"
      enterFrom="opacity-0"
      enterTo="opacity-100"
    >
      {/* <Popover.Overlay className="fixed inset-0 bg-black opacity-30" /> */}
      <Popover.Panel className="absolute z-20 bg-white rounded-xl w-72 border border-gray-300 drop-shadow-sm" style={{ top: '40px', right: rightOriented ? '0px' : undefined }}>
        <div className="grid p-4 gap-0 px-2" style={{ borderBottom: '1px solid rgb(232, 232, 232)' }}>
          <a href="https://whitepaper.tkn.xyz" className="font-semibold text-left px-4 py-1.5 hover:bg-gray-100 rounded-lg">Whitepaper</a>
          <a href="https://apps.apple.com/us/app/tkn-decentralized-token-data/id6447381005?platform=iphone" className="font-semibold text-left px-4 py-1.5 hover:bg-gray-100 rounded-lg">iOS App</a>
          <a href="https://docs.tkn.xyz" className="font-semibold text-left px-4 py-1.5 hover:bg-gray-100 rounded-lg">Developers</a>
          <a href="https://legacy.tkn.eth.limo/" className="font-semibold text-left px-4 py-1.5 hover:bg-gray-100 rounded-lg"><div className="">Legacy Explorer</div></a>
          <a href="https://tokenlists.org/token-list?url=list.tkn.eth" className="font-semibold text-left px-4 py-1.5 hover:bg-gray-100 rounded-lg">TokenList</a>
          <a href="https://tkn.eth.limo/" className="font-semibold text-left px-4 py-1.5 hover:bg-gray-100 rounded-lg">DWeb IPFS App</a>
          <a href="https://app.deform.cc/form/784f4107-4c46-44b4-85b6-fc6557384ad8" className="font-semibold text-left px-4 py-1.5 hover:bg-gray-100 rounded-lg">Feedback</a>
        </div>
        <div className="grid grid-cols-3 px-5 py-4 gap-0">
            <a href="https://twitter.com/TokenDao_" target="_blank" rel="noopener noreferrer" className='flex items-center justify-center cursor-pointer hover:bg-gray-50 rounded-lg'>
              <TwitterIcon style={{ fill: '#9B9BA6', height: '26px' }} />
            </a>
            <a href="https://github.com/TickerDao/" target="_blank" rel="noopener noreferrer" className='flex items-center justify-center cursor-pointer hover:bg-gray-50 rounded-lg'>
              <GitHubIcon style={{ fill: '#9B9BA6', height: '26px'  }} />
            </a>
            <a href="https://discord.gg/dEc9GHjKUP" target="_blank" rel="noopener noreferrer" className='flex items-center justify-center cursor-pointer hover:bg-gray-50 rounded-lg'>
              <DiscordIcon style={{ fill: '#9B9BA6', height: '26px'  }} />
            </a>
        </div>
      </Popover.Panel>
    </Transition>
  );
}


// const people = [
//   { name: 'Lindsay Walton', title: 'Front-end Developer', email: 'lindsay.walton@example.com', role: 'Member' },
//   { name: 'Lindsay Walton', title: 'Front-end Developer', email: 'lindsay.walton@example.com', role: 'Member' },
//   { name: 'Lindsay Walton', title: 'Front-end Developer', email: 'lindsay.walton@example.com', role: 'Member' },
//   // More people...
// ]

// export function TokenTable() {
//   return (
//     <div className="max-w-5xl content-center px-4 sm:px-6 lg:px-8">

//       <div className="mt-8 flex flex-col">
//         <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
//           <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
//             <table className="min-w-full divide-y divide-gray-300">
//               <thead>
//                 <tr>
//                   <th
//                     scope="col"
//                     className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
//                   >
//                     Logo
//                   </th>
//                   <th scope="col" className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
//                     Ticker
//                   </th>
//                   <th scope="col" className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
//                     Name
//                   </th>
//                   <th scope="col" className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
//                     Description
//                   </th>
//                   <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6 md:pr-0">
//                     <span className="sr-only">Edit</span>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {people.map((person) => (
//                   <tr key={person.email}>
//                     <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 md:pl-0">
//                       {person.name}
//                     </td>
//                     <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500">{person.title}</td>
//                     <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500">{person.email}</td>
//                     <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500">{person.role}</td>
//                     <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 md:pr-0">
//                       <a href="#" className="text-indigo-600 hover:text-indigo-900">
//                         Edit<span className="sr-only">, {person.name}</span>
//                       </a>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export function TokenViewToggle({ updateView }) {
//   return (
//     <span className="isolate inline-flex rounded-md shadow-sm">
//       <button
//         type="button"
//         onClick={() => updateView("tokens")}
//         className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
//       >
//         View Tokens
//       </button>

//       <button
//         type="button"
//         onClick={() => updateView("submissions")}
//         className="relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
//       >
//         View Data Edits
//       </button>
//     </span>
//   )
// }

// export function TokenInfoLevelToggle({ detailLevel, setDetailLevel }) {
//   return (
//     <span className="isolate inline-flex rounded-md shadow-sm">
//       <button
//         type="button"
//         onClick={() => setDetailLevel("simple")}
//         className={`${detailLevel === 'simple' ? "active" : ""} relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`}
//       >
//         Simple
//       </button>

//       <button
//         type="button"
//         onClick={() => setDetailLevel("expanded")}
//         className={`${detailLevel === 'expanded' ? "active" : ""} relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`}
//       >
//         Expanded
//       </button>
//     </span>
//   )
// }


export function LoginPromptModal({ open, setOpen, openConnectModal, closeConnectModal, setSelectedView}) {
  // const [open, setOpen] = useState(true)

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" open={open} className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                <div>
                  {/* <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                    <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                  </div> */}
                  <div className="mt-0 text-center sm:mt-0">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                      Connect to TKN
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Login with your Ethereum wallet to edit the TKN dataset.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6">
                  
                  <ConnectButton.Custom>
                    {({
                      account,
                      chain,
                      openAccountModal,
                      openChainModal,
                      openConnectModal,
                      authenticationStatus,
                      mounted,
                    }) => {
                      // Note: If your app doesn't use authentication, you
                      // can remove all 'authenticationStatus' checks
                      const ready = mounted && authenticationStatus !== 'loading';
                      const connected =
                        ready &&
                        account &&
                        chain &&
                        (!authenticationStatus ||
                          authenticationStatus === 'authenticated');

                      if (connected) {
                        closeConnectModal()
                        setSelectedView("editTokens")
                      }

                      return (
                        <div
                          {...(!ready && {
                            'aria-hidden': true,
                            'style': {
                              opacity: 0,
                              pointerEvents: 'none',
                              userSelect: 'none',
                            },
                          })}
                        >
                          {(() => {
                            if (!connected) {
                              return (
                                <button 
                                style={{ backgroundColor: primaryCTAButtonColor, fontWeight: primaryCTAFontWeight }}
                                onClick={openConnectModal} type="button" className='inline-flex w-full justify-center rounded-md border border-transparent  px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:text-sm'>
                                  Connect Wallet
                                </button>
                              );
                            }

                            if (chain.unsupported) {
                              return (
                                <button 
                                style={{ backgroundColor: primaryCTAButtonColor }}
                                onClick={openChainModal} type="button" className='inline-flex w-full justify-center rounded-md border border-transparent  px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:text-sm'>
                                  Wrong network
                                </button>
                              );
                            }

                            return (
                              <div style={{ display: 'flex', gap: 12 }}>
                                <button
                                  onClick={openChainModal}
                                  style={{ display: 'flex', alignItems: 'center' }}
                                  type="button"
                                >
                                  {chain.hasIcon && (
                                    <div
                                      style={{
                                        background: chain.iconBackground,
                                        width: 12,
                                        height: 12,
                                        borderRadius: 999,
                                        overflow: 'hidden',
                                        marginRight: 4,
                                      }}
                                    >
                                      {chain.iconUrl && (
                                        <img
                                          alt={chain.name ?? 'Chain icon'}
                                          src={chain.iconUrl}
                                          style={{ width: 12, height: 12 }}
                                        />
                                      )}
                                    </div>
                                  )}
                                  {chain.name}
                                </button>

                                <button onClick={openAccountModal} type="button">
                                  {account.displayName}
                                  {account.displayBalance
                                    ? ` (${account.displayBalance})`
                                    : ''}
                                </button>
                              </div>
                            );
                          })()}
                        </div>
                      );
                    }}
                  </ConnectButton.Custom>

                  {/* <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                    onClick={() => setOpen(false)}
                  >
                    Go back to dashboard
                  </button> */}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

// /* This example requires Tailwind CSS v3.0+ */
// export function CTAHero({ setSelectedView, loggedInAddress, openConnectModal }) {
//   function activateEditing(e) {
//     setSelectedView("editTokens")
//   }
//   function connectAccount(e) {
//     openConnectModal(true)
//   }
//   return (
//     <div className="">

//       <div className="mx-auto max-w-7xl py-24 sm:px-6 sm:py-32 lg:px-8">
//       <div className="bg"></div>
//       <div className="bg bg2"></div>
//       <div className="bg bg3"></div>
//         <div style={{backgroundColor: '#ff4969'}} className=" relative isolate overflow-hidden  px-6 py-24 text-center shadow-2xl sm:rounded-3xl sm:px-16 ">
//           <h2 className="mx-auto max-w-2xl text-4xl font-bold tracking-tight text-white">Token Name Service</h2>
//           <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-300">
//           The on-chain, decentralized, public utility, <b>Token List</b><br></br>
//           that anyone can edit.</p>
//           <Lottie animationData={brickAnimation} loop={true} width={200} height={200} style={{ width: '100px', margin: 'auto' }} />
//           <div className="mt-10 flex items-center justify-center gap-x-6">
//             <button
//               onClick={loggedInAddress ? activateEditing : connectAccount}
//               className="rounded-md bg-white px-3.5 py-1.5 text-base font-semibold leading-7 text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
//             >
//               Edit Data
//             </button>
//             <a href="https://tkn.xyz/#developer-docs-start" className="text-base font-semibold leading-7 text-white">
//               Developer Docs <span aria-hidden="true">→</span>
//             </a>
//           </div>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             viewBox="0 0 1024 1024"
//             className="absolute top-1/2 left-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)]"
//             aria-hidden="true"
//           >
//             <circle cx={512} cy={512} r={512} fill="url(#827591b1-ce8c-4110-b064-7cb85a0b1217)" fillOpacity="0.7" />
//             <defs>
//               <radialGradient id="827591b1-ce8c-4110-b064-7cb85a0b1217">
//                 <stop stopColor="#7775D6" />
//                 <stop offset={1} stopColor="#E935C1" />
//               </radialGradient>
//             </defs>
//           </svg>
//         </div>
//       </div>

//     </div>
//   )
// }


export function LeftAlignedHero({ setSelectedView, loggedInAddress, openConnectModal, setShowHero }) {
  function activateEditing(e) {
    setSelectedView("editTokens")
  }
  function connectAccount(e) {
    openConnectModal(true)
  }
  function minimizeHero(e) {
    setShowHero(false)
  }
  return (
    <div className="bg-gray-100">
      <div className="mx-auto max-w-7xl sm:pt-0 sm:px-6 " style={{ display: 'grid' }}>
        <div style={{backgroundColor: '#393939', zIndex: 10 }} className="relative isolate overflow-hidden sm:pb-10 pb-5 sm:pb-10 sm:mb-5 sm:mt-2 px-6 sm:pt-10 pt-5 mt-2 mb-3 sm:rounded-xl sm:px-16 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0 lg:pb-0 lg:mb-7 border-3 border-gray-300 lg:justify-between">
          <div className="absolute w-full px-6 -ml-32 h-full flex top-0 items-center">
            <TickerStream/>
          </div>
          <svg
            viewBox="0 0 1024 1024"
            className="absolute top-1/2 left-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:translate-y-0 lg:-translate-x-1/2"
            aria-hidden="true"
          >
            <circle cx={512} cy={512} r={512} fill="url(#759c1415-0410-454c-8f7c-9a820de03641)" fillOpacity="0.7" />
            <defs>
              <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641">
                <stop stopColor="oldlace" />
                <stop offset={1} stopColor="antiquewhite" />
              </radialGradient>
            </defs>
          </svg>
          <div className="hero-text-py mx-auto hero-text-y text-center lg:mx-0 lg:flex-auto lg:py-20 lg:text-left backdrop-blur lg:px-6 pt-1 sm:pt-0" style={{ position: 'inherit '}}>
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl" style={{ borderRadius: '12px' }}>
              Token Name Service
             
            </h2>
            <p className="sm:mt-6 mt-4 text-lg leading-8 text-white " style={{ borderRadius: '12px' }}>
              The public
              <span className='hidden md:inline'> infrastructure,</span> onchain, 
              <b>Token Database</b>
              <span className='lg:block hidden'>
                That anyone can curate.
              </span>
            </p>

            {/* <p className="sm:mt-6 mt-4 text-lg leading-8 text-white">The public<span className='hidden md:inline'> infrastructure,</span> onchain, <b>Token Database</b><div className='lg:block hidden'>
            That anyone can edit.</div></p> */}

            <div className="sm:mt-7 mt-5 items-center justify-center gap-x-6 lg:justify-start lg:flex hidden">
              {/* <Link to="/edit"> */}
                <a href="https://whitepaper.tkn.xyz" 
                  className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Whitepaper
                </a>
                {/* <a href="https://docs.tkn.xyz"
                  className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Documentation
                </a> */}
              {/* </Link> */}
              <Link to="/edit">

              <button 
                onClick={loggedInAddress ? activateEditing : connectAccount}
                className="text-sm font-semibold leading-6 text-white " style={{ borderRadius: '12px' }}>
                  Edit Data <span aria-hidden="true">→</span>
              </button>
              </Link>

            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center'}} className="hero-text-py mx-auto lg:mx-0 lg:px-6 relative justify-center lg:justify-end backdrop-blur pb-1 sm:pb-0">
            <FundedByLogos />
          </div>

          <div
            className="hero-dismiss-button"
            onClick={minimizeHero}
            style={{
              cursor: 'pointer',
              marginTop: '10px',
              paddingTop: '0px',
              position: 'absolute',
              zIndex: 1,
              width: '26px',
              height: '26px',
            }}
          >
            {/* SVG for screen width greater than 640px */}
            <svg className="large-screen-svg" width="26" height="26" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="52" height="52" rx="26" fill="white"/>
            <line x1="16.0628" y1="35.1723" x2="36.1723" y2="15.9373" stroke="#393939" strokeWidth="4" strokeLinecap="round"/>
            <line x1="15.8277" y1="15.9372" x2="35.9372" y2="35.1723" stroke="#393939" strokeWidth="4" strokeLinecap="round"/>
            </svg>


            {/* SVG for screen width 640px or below */}

            <svg  className="small-screen-svg" width="26" height="26" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="52" height="52" fill="white"></rect>
              <line x1="16.0628" y1="35.1723" x2="36.1723" y2="15.9373" stroke="#837E78" strokeWidth="4" strokeLinecap="round"></line>
              <line x1="15.8277" y1="15.9372" x2="35.9372" y2="35.1723" stroke="#837E78" strokeWidth="4" strokeLinecap="round"></line>
            </svg>

          </div>


{/* 
          <div 
          onClick={minimizeHero}
          className="shadow" style={{
            cursor: 'pointer',
            border: 'rgb(219, 219, 219)',
            color: 'rgb(255 255 255)',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '100px',
            fontWeight: '400',
            fontSize: '17px',
            paddingTop: '20px',
            paddingBottom: '8px',
            borderStyle: 'inherit',
            borderRadius: '8px',
            marginTop: '10px',
            position: 'relative',
            top: '-27px',
            zIndex: '1',
            backgroundColor: 'rgb(219, 219, 219)'
          }}>
            Minimize
          </div> */}
        </div>
      </div>
    </div>
  )
}

const FundedByLogos = () => {
  return (
    <a href="https://ensgrants.xyz/rounds/22/proposals/597">
      <div className="sm:mt-6 mt-4 text-lg leading-8 text-white font-extrabold justify-center">
        <div className="flex justify-between items-center " style={{ borderRadius: '12px' }}>
          <div className="flex flex-col">
            <div className="flex items-center justify-center lg:justify-end">
              <div className='mr-4'>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-10 h-11 lg:w-20 lg:h-20"
                  fill="none"
                  viewBox="0 0 270 301"
                >
                  <path
                    fill="#fff"
                    d="M34.557 121.371c2.965 6.337 10.303 18.864 10.303 18.864L129.69 0 46.898 57.813a36.133 36.133 0 00-11.785 12.971 60 60 0 00-.556 50.587zM.945 167.55a94.389 94.389 0 0037.06 68.598l91.575 63.854S72.285 217.433 23.959 135.271a82.983 82.983 0 01-9.71-28.017 44.85 44.85 0 010-13.453c-1.26 2.335-3.706 7.115-3.706 7.115a108.772 108.772 0 00-9.895 31.687 193.744 193.744 0 00.297 34.947zM234.57 178.627c-2.965-6.337-10.302-18.863-10.302-18.863l-84.83 140.234 82.791-57.776a36.124 36.124 0 0011.785-12.971 59.991 59.991 0 00.556-50.624zM268.185 132.452a94.4 94.4 0 00-37.06-68.598L139.55 0s57.257 82.57 105.621 164.731a82.98 82.98 0 019.672 28.018 44.802 44.802 0 010 13.452c1.26-2.334 3.706-7.115 3.706-7.115 4.9-9.994 8.237-20.68 9.895-31.686.967-11.634.88-23.33-.259-34.948z"
                  ></path>
                  <path
                    style={{ mixBlendMode: "color" }}
                    fill="#fff"
                    d="M35.114 70.784a36.134 36.134 0 0111.785-12.97L129.691 0l-84.83 140.272s-7.412-12.526-10.303-18.864a59.998 59.998 0 01.556-50.624zM.944 167.548a94.389 94.389 0 0037.06 68.598L129.58 300S72.285 217.431 23.959 135.269a82.981 82.981 0 01-9.71-28.018 44.837 44.837 0 010-13.452c-1.26 2.334-3.706 7.115-3.706 7.115A108.775 108.775 0 00.648 132.6a193.755 193.755 0 00.297 34.948zm233.478 11.118c-2.965-6.337-10.302-18.864-10.302-18.864L139.438 300l82.792-57.776a36.142 36.142 0 0011.785-12.971 60.006 60.006 0 00.555-50.624l-.148.037zm33.614-46.177a94.389 94.389 0 00-37.06-68.598L139.549 0s57.257 82.57 105.621 164.731a82.98 82.98 0 019.672 28.018 44.802 44.802 0 010 13.452c1.26-2.334 3.706-7.115 3.706-7.115 4.9-9.994 8.238-20.68 9.895-31.686.967-11.634.88-23.33-.259-34.948l-.148.037z"
                  ></path>
                </svg>
              </div>
              <p>and</p>
              <div className='ml-4'>
                <svg viewBox="80.045 19.222 36 36" className="w-10 h-10 lg:w-20 lg:h-20">
                  <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M23 41C13.0589 41 5 32.9411 5 23C5 13.0589 13.0589 5 23 5C32.9411 5 41 13.0589 41 23C41 32.9411 32.9411 41 23 41ZM14.3619 29.1866C14.9451 29.3702 15.5769 29.462 16.2573 29.462C17.8233 29.462 19.0707 29.1002 19.9995 28.3766C20.9283 27.6422 21.5763 26.5352 21.9435 25.0556C22.0515 24.5912 22.1541 24.1268 22.2513 23.6624C22.3593 23.198 22.4511 22.7282 22.5267 22.253C22.6563 21.5186 22.6347 20.876 22.4619 20.3252C22.2999 19.7744 22.0137 19.31 21.6033 18.932C21.2037 18.554 20.7123 18.2732 20.1291 18.0896C19.5567 17.8952 18.9303 17.798 18.2499 17.798C16.6731 17.798 15.4203 18.176 14.4915 18.932C13.5627 19.688 12.9201 20.795 12.5637 22.253C12.4557 22.7282 12.3477 23.198 12.2397 23.6624C12.1425 24.1268 12.0507 24.5912 11.9643 25.0556C11.8455 25.79 11.8671 26.4326 12.0291 26.9834C12.2019 27.5342 12.4881 27.9932 12.8877 28.3604C13.2873 28.7276 13.7787 29.003 14.3619 29.1866ZM18.0069 26.6108C17.5641 26.9564 17.0511 27.1292 16.4679 27.1292C15.8739 27.1292 15.4473 26.9564 15.1881 26.6108C14.9289 26.2652 14.8641 25.7144 14.9937 24.9584C15.0801 24.4832 15.1665 24.035 15.2529 23.6138C15.3501 23.1926 15.4581 22.7552 15.5769 22.3016C15.7605 21.5456 16.0683 20.9948 16.5003 20.6492C16.9431 20.3036 17.4561 20.1308 18.0393 20.1308C18.6225 20.1308 19.0491 20.3036 19.3191 20.6492C19.5891 20.9948 19.6539 21.5456 19.5135 22.3016C19.4379 22.7552 19.3515 23.1926 19.2543 23.6138C19.1679 24.035 19.0653 24.4832 18.9465 24.9584C18.7629 25.7144 18.4497 26.2652 18.0069 26.6108ZM22.9303 29.1866C22.9951 29.2622 23.0815 29.3 23.1895 29.3H25.3927C25.5115 29.3 25.6141 29.2622 25.7005 29.1866C25.7977 29.111 25.8571 29.0138 25.8787 28.895L26.6239 25.3472H28.8109C30.2041 25.3472 31.3111 25.0502 32.1319 24.4562C32.9635 23.8622 33.5143 22.9442 33.7843 21.7022C33.9139 21.0758 33.9085 20.5304 33.7681 20.066C33.6277 19.5908 33.3793 19.1966 33.0229 18.8834C32.6665 18.5702 32.2183 18.338 31.6783 18.1868C31.1491 18.0356 30.5551 17.96 29.8963 17.96H25.5871C25.4791 17.96 25.3765 17.9978 25.2793 18.0734C25.1821 18.149 25.1227 18.2462 25.1011 18.365L22.8655 28.895C22.8439 29.0138 22.8655 29.111 22.9303 29.1866ZM28.9081 23.1116H27.0451L27.6769 20.2118H29.6209C30.0097 20.2118 30.2959 20.2766 30.4795 20.4062C30.6739 20.5358 30.7873 20.7086 30.8197 20.9246C30.8521 21.1406 30.8413 21.389 30.7873 21.6698C30.6793 22.1558 30.4471 22.5176 30.0907 22.7552C29.7451 22.9928 29.3509 23.1116 28.9081 23.1116Z" transform="matrix(1, 0, 0, 1, 75.044846, 14.22225)"></path>
                </svg>
              </div>
            </div>
            <p className='mt-4'>Funded with grants from</p>
          </div>
          <div className='-z-1 flex flex-col ' style={{ transform: 'scale(1.2), background: #bbb' }}></div>
        </div>
      </div>
    </a>
  );
};

const PriceDataCells = ({ ticker, price }) => {
  const [data, setData] = useState(null);
  // const [ticker, setTicker] = useState(null);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // const response = await fetch(`https://feed.tkn.xyz/p/${ticker}`);
  //       // const jsonData = await response.json();
  //       // // data.data = jsonData;
  //       // // setTicker(ticker)
  //       // if (jsonData.DISPLAY) {
  //       //   console.log(ticker, jsonData)
  //       //   setData(jsonData);
  //       // }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  //   fetchData();
  // }, [ticker])

  if (price) { 
    return <>
      <td className="text-right  py-4 px-3 text-sm text-gray-500" style={{ overflowWrap: 'break-word', maxWidth: '115px', direction: 'rtl' }}>
        <Link to={`/${ticker.toLowerCase()}`}>
          { price.PRICE.replace(/\s/g, "") }
          {/* ${ (Math.round(data.RAW[ticker].USD.PRICE * 100) / 100).toLocaleString("en-US") } */}
        </Link>
      </td>
      <td className="text-left whitespace-nowrap py-4 px-3 text-sm text-gray-500" style={{ direction: 'ltr', position: "relative", left: price.CHANGEPCT24HOUR >= 0.00 ? "0px" : "-5.5px" }}>
        <Link to={`/${ticker.toLowerCase()}`}>
          <span className={price.CHANGEPCT24HOUR > 0 ? "text-green-600" : price.CHANGEPCT24HOUR < 0 ? "text-red-600" : ""}>
            { price.CHANGEPCT24HOUR } %
          </span>
        </Link>
      </td>
    </>
  } else {
    return <>
      <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500">
        Loading...
      </td>
      <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-500">
        Loading...
      </td>
    </>
  }
}

function ImageFromIPFS({ src, alt, width, height, ...props }) {
  const initialGatewayIndex = Number(localStorage.getItem('gatewayIndex') || 0);
  const [currentGatewayIndex, setCurrentGatewayIndex] = useState(initialGatewayIndex);
  const [imgSrc, setImgSrc] = useState('');

  // Parse the CID from the src URL
  const cid = src.includes('http') ? src.split('ipfs/')[1] : src;

  // Preload the image before rendering
  const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      let image = new Image();
      image.src = url;
      image.onload = () => resolve(url);
      image.onerror = () => reject();
    });
  };

  // Update the imgSrc when gateway changes
  useEffect(() => {
    const loadImage = async () => {
      try {
        const url = `${ipfsGatewayUrls[currentGatewayIndex]}${cid}`;
        const preloadedUrl = await preloadImage(url);
        localStorage.setItem('gatewayIndex', currentGatewayIndex.toString());
        setImgSrc(preloadedUrl);
      } catch {
        if (currentGatewayIndex + 1 < ipfsGatewayUrls.length) {
          setCurrentGatewayIndex((currentGatewayIndex + 1) % ipfsGatewayUrls.length);
        } else {
          localStorage.removeItem('gatewayIndex');
        }
      }
    };
    loadImage();
  }, [currentGatewayIndex, cid]);

  return imgSrc ? <img src={imgSrc} alt={alt} width={width} height={height} {...props} /> : <img src="./placeholder.png" alt="Placeholder" width={width} height={height} {...props} />;
}



// render a react component with rounded corners containing an animated gradient background
export function Animator() {
  return (
    <div className="rounded-lg bg-gradient-to-r from-green-400 to-blue-500 animate-gradient-x p-4">
      <div className="animate-pulse flex space-x-4">
        <div className="rounded-full bg-gray-900 h-12 w-12" />
        <div className="flex-1 space-y-4 py-1">
          <div className="h-4 bg-gray-900 rounded w-3/4" />
          <div className="space-y-2">
            <div className="h-4 bg-gray-900 rounded" />
            <div className="h-4 bg-gray-900 rounded w-5/6" />
          </div>
        </div>
      </div>
    </div>
  )
}

// class ScrollToTop extends Component {
//   componentDidUpdate(prevProps) {
//     const { location } = this.props;
//     if (location.pathname !== prevProps.location.pathname) {
//       window.scrollTo(0, 0);                
//     }
//   }

//   render() {
//     const { children } = this.props;
//     return children;
//   }
// }
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const pathname = useLocation().pathname;
  const isInEditMode = pathname.startsWith('/edit');

  const { address } = useAccount()
  
  // const { openConnectModal } = useConnectModal();
  // openConnectModal()
  const [view, updateView] = useState("tokens")
  let [isModalLoginPromptOpen, setIsModalLoginPromptOpen] = useState(false);

  useEffect(() => {
    // execute on location change
    // setCount(count + 1);
    console.log('Location changed!', pathname, 'account', address);
    const isInEditMode = pathname.startsWith('/edit');

    if (isInEditMode && !address) {
      console.log("User is in edit mode while logged out. Prompting to connect.")
      // openConnectModal()
      setIsModalLoginPromptOpen(true)
    } else {
      setIsModalLoginPromptOpen(false)
    }
}, [pathname, isInEditMode, address]);

  const openConnectionModal = (shouldOpen) => {
    // TODO: Change behavior if user is logged in
    setIsModalLoginPromptOpen(shouldOpen)
  }

  const closeConnectionModal = () => {
    setIsModalLoginPromptOpen(false)
  }

  return (
    // <Routes>
      <WagmiConfig client={wagmiClient}>
        {/* <RainbowKitProvider chains={chains}> */}
        <RainbowKitProvider chains={chains} initialChain={1} theme={darkTheme({
          borderRadius: 'small',
          accentColor: primaryCTAButtonColor,
          accentColorForeground: 'white',
          fontStack: 'system',
        })}>
          <div className="App">
            <TokenHeader
              updateView={updateView} />
            <Content selectedView={view} setSelectedView={updateView} openConnectModal={openConnectionModal} setIsModalLoginPromptOpen={ setIsModalLoginPromptOpen } />
            <LoginPromptModal open={isModalLoginPromptOpen} setOpen={setIsModalLoginPromptOpen} openConnectModal={openConnectionModal} closeConnectModal={closeConnectionModal} setSelectedView={updateView} />
          </div>
        </RainbowKitProvider>
      </WagmiConfig>
    // </Routes>
  );
}

export default App